import {
    ColumnChooser,
    ColumnDirective,
    ColumnMenu,
    ColumnsDirective,
    ContextMenu,
    Filter,
    FilterSettingsModel,
    GridComponent,
    Group,
    Page,
    PageSettingsModel,
    Reorder,
    Resize,
    Edit,
    EditSettingsModel,
    Inject,
    Toolbar,
    Sort,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import {all_information, GetBackendUrlForGlobalFunctions, GetErpTypeFromConfig, loadingShow} from '../../App';
import {
    AddEditOperationsByTemplate,
    AddOperations,
    DeleteOperations,
    EditOperations,
    getOperations,
} from '../../services/Operations/OperationServices';
import Message from '../../utils/Message/Message';
import {MdAssignmentTurnedIn} from 'react-icons/md';
import {
    ButtonComponent,
    ChipDirective,
    ChipListComponent,
    ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import {
    MultiSelectComponent as MultiSelectC,
    DropDownListComponent,
    DropDownList,
} from '@syncfusion/ej2-react-dropdowns';
import {
    ButtonPropsModel, TooltipComponent,
} from '@syncfusion/ej2-react-popups';
import {ThemeContext} from '../../context/theme.context';
import {DateRangePickerComponent, DateTimePickerComponent} from '@syncfusion/ej2-react-calendars';
import {Query} from '@syncfusion/ej2-data';
import {BsSearch} from 'react-icons/bs';
import GlobalSearch from '../../components/GlobalSearch';
import {TextBox, TextBoxComponent} from '@syncfusion/ej2-react-inputs';
import {getPriority} from '../../utils/GetPriorityColor';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    setIsPlanSelected,
    setSearchCaseGantt,
    setSearchCaseOp,
    setSearchCaseOrder,
} from '../../redux/search.slice';
import {getParamsDD} from '../../utils/GridParams';
import {
    GlobalDropDown,
    GlobalMultiSelection,
} from '../../components/GlobalDropDown';
import GlobalDialog from '../../components/GlobalDialog';
import {
    convertToDate,
    extractCharacters,
    extractNumbers, extractStringValue,
    getAdjustedDatas,
    groupTasksByDate,
    SavePointEdit,
    transformToMultiTableFormat
} from '../../utils/Methods/methods';
import GlobalGrid from '../../components/GlobalGrid';
import {getTrades} from '../../services/tradeperson/trades';
import {getGlobalFilter} from '../../services/GlobalFilter/GlobalFilterServices';

import GlobalPlannedOrderGrid from "../../components/GlobalPlannedOrderGrid";
import {io} from "socket.io-client";
import {EditProntoOrders, EditWorkOrderTrades} from "../../services/ProntoServices/WorkOrderService/WorkOrderService";
import {AxiosResponse} from "axios";
import {SendRequest} from "../../utils/CreateRequest";
import {GetTablenameFromTask} from "../../utils/GetTablenameFromTask";
import {GetMaxProntoRowIdData} from "../../services/CloudScheduler/CloudSchedulerServices";
import {addToQuery} from "../../utils/BussinesRuleBuilder";
import moment from "moment-timezone";
import AssignWorkOrderDialog from "./AssignWorkOrderDialog";
import MassiveOrderEdit from '../../utils/MassOrderEdit';

interface IProps {
    needDidMount: boolean;
    outter_asset_code?: string | undefined;
    needExpandStatus?: boolean;
}

let init_query: string = '';
let model: Array<any> = [];
let tradeData: Array<any> = [];
let buttonShiftAssignment: ButtonPropsModel[];
let buttonTeamAssignment: ButtonPropsModel[];
let current_query: string = '';
const editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: false,
    allowDeleting: true,
    showDeleteConfirmDialog: true,
};
const editOptionsOperationTemplateDialog: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    showDeleteConfirmDialog: true,
    // mode: 'Batch',
    // allowNextRowEdit: true,
};
let theQueryScheduleNumber = '';
let theQueryStatuses = '';
let theQueryPrioritys = '';
let theQueryTeams = '';
let theQueryShifts = '';
let theQueryTrades = '';
let theQueryOPStatus = '';
let theQueryDepartment = '';
let theQuerySection = '';
let theQueryProntoReference = '';
let theQueryHoldReason = '';
let theQueryRevisionCode = '';
let theQueryAsset = '';
let theQueryParentAsset = '';
let theQueryOutterAsset = '';
let theQueryType = '';
let theQueryHasProblem = '';
let theQueryResp = '';
let theQueryDate = '';
let theQuerySearch = '';
let theQueryPlanId = '';
let theQueryWorkOrderCode = '';
let theQueryReference = '';
const Operations = ({outter_asset_code, needExpandStatus}: IProps) => {
    const [selectedOrderDatas, setSelectedOrderDatas] = useState<any[]>([]);
    let teamFMSCom: MultiSelectC = new MultiSelectC({});
    let shiftFMSCom: MultiSelectC = new MultiSelectC({});
    let tradeFMSCom: MultiSelectC = new MultiSelectC({});
    let OPStatusFMSCom: MultiSelectC = new MultiSelectC({});

    let priorityFMSComValue: Array<any> = [];
    let departmentFMSComValue: Array<any> = [];
    let sectionFMSComValue: Array<any> = [];
    let prontoReferenceFMSComValue: Array<any> = [];
    let holdReasonFMSComValue: Array<any> = [];
    let revisionCodeFMSComValue: Array<any> = [];
    let statusFMSComValue: Array<any> = [];
    let teamFMSComValue: Array<any> = [];
    let shiftFMSComValue: Array<any> = [];
    let tradeFMSComValue: Array<any> = [];
    let OPStatusFMSComValue: Array<any> = [];
    let typeFMSComValue: Array<any> = [];
    let hasProblemValue: Array<any> = [];

    let respFMSComValue: Array<any> = [];
    // let referenceFMSComValue: string = '';
    let workorderCodeFMSComValue: string = '';
    let ScheduleNumberFMSComValue: string = '';
    let assetFMSComValue: string = '';
    let parentAssetFMSComValue: string = '';
    let statusFMSCom: MultiSelectC = new MultiSelectC({});
    let schdeduleStartDateVal: any = '';
    let plannedStartDateVal: any = '';
    let departmentFMSCom: MultiSelectC = new MultiSelectC({});
    let sectionFMSCom: MultiSelectC = new MultiSelectC({});
    let prontoReferenceFMSCom: MultiSelectC = new MultiSelectC({});
    let holdReasonFMSCom: MultiSelectC = new MultiSelectC({});
    let revisionCodeFMSCom: MultiSelectC = new MultiSelectC({});
    let typeFMSCom: MultiSelectC = new MultiSelectC({});
    let hasProblem: MultiSelectC = new MultiSelectC({});
    let respFMSCom: MultiSelectC = new MultiSelectC({});
    let startDateFMSCom: any = null;
    let plannedStartDateFMSCom: any = null;
    let priorityFMSCom: MultiSelectC = new MultiSelectC({});
    let assetFMSCom: TextBoxComponent = new TextBoxComponent({});
    let parentAssetFMSCom: TextBoxComponent = new TextBoxComponent({});
    let referenceFMSCom: TextBoxComponent = new TextBoxComponent({});
    let workorderCodeFMSCom: TextBoxComponent = new TextBoxComponent({});
    let ScheduleNumberFMSCom: TextBoxComponent = new TextBoxComponent({});
    let priorityFMCComValue: Array<any> = [];
    let statusFMCComValue: Array<any> = [];
    let typeFMCComValue: Array<any> = [];
    let respFMCComValue: Array<any> = [];
    let assetFMCComValue: Array<any> = [];
    const FilterOptions: FilterSettingsModel = {type: 'Excel'};
    const pageOptions: PageSettingsModel = {
        currentPage: 1,
        pageSize: 100,
        pageCount: 10,
        pageSizes: false,
    };
    let current_page: number =
        250 / (pageOptions.pageSize !== undefined ? pageOptions.pageSize : 1);
    const gridCPOp = React.useRef<GridComponent | null>(null);
    let gridOpTemplate: GridComponent;
    //let plan_id: number = -1;
    const [plan_id, setPlanId] = useState(-1);
    let selectedChips: Array<any> = [];
    let selectedChipValues: Array<any> = [];
    let dropDownListObjectShiftElment: DropDownListComponent;
    let dropDownListObjectTeamElment: DropDownListComponent;
    let queryOfAsset = new Query().take(20);
    let global_fetch_size = useSelector(
        (state: any) => state.search.page_range_from_settings
    );
    let page_range_from_settings = global_fetch_size.toString();
    let current_page_range = `1$${page_range_from_settings}`;

    let toolbarOptions: any;
    var contextMenuItems = [
        {
            text: 'Show Materials',
            tooltipText: 'view',
            prefixIcon: 'e-view',
            id: 'materials',
        },
    ];
    let searchText: string = '';
    let searchTextBox: TextBoxComponent;
    const [referenceFMSComValue, setreferenceFMSComValue] = useState<string>('');

    let gmt = useSelector((state: any) => state.search.server_gmt);
    let serverOffsetMillis: number = gmt != null
        ? 60 * 1000 * -(gmt * 60)
        : 60 * 1000 * -(11 * 60);
    let localOffset: number = new Date().getTimezoneOffset();
    let localOffsetMillis: number = 60 * 1000 * localOffset;
    const ERP_TYPE = GetErpTypeFromConfig();
    const erpTypeName = 'MEX';
    const dispatch = useDispatch();
    const reduxSearchS = useSelector((state: any) => state.search);
    const [data, setData] = useState<Array<any>>([]);
    const [PriorityColorData, setPriorityColorData] = useState<Array<any>>([]);
    const [hideDeleteDialog, setHideDeleteDialog] = useState(false);
    const [hideAssignTeamDialog, setHideAssignTeamDialog] = useState(false);
    const [searchCase, setSearchCase] = useState('');
    const [hideSchedulerTimeDialog, setHideSchedulerTimeDialog] = useState(false);
    const [defaultConfirmScheduleDate, setDefaultConfirmScheduleDate] = useState<Date | undefined>(undefined);
    const [hideDialogOrder, setHideDialogOrder] = useState<boolean>(false);
    const [hideDialogEventPlan, setHideDialogEventPlan] = useState(false);
    const [theSearchText, setTheSearchText] = useState<string>('');
    let dateTimePicker: DateTimePickerComponent = new DateTimePickerComponent({});
    const socket = io(GetBackendUrlForGlobalFunctions() as string, {
        autoConnect: false,
        transports: ['websocket'],
    });
    const [isFilterActive, setIsFilterActive] = useState(false);
    let isAgentAlive = false;
    const [showOperationTemplateModal, setShowOperationTemplateModal] =
        useState<boolean>(false);
    const [selectedOrderDetail, setSelectedOrderDetail] = useState<Array<any>>(
        []
    );
    var moment = require('moment-timezone');
    const [selectedOrderCodes, setSelectedOrderCodes] = useState<string>('');
    searchText = reduxSearchS.searchCaseOperation;
    $('#operation-search').val(searchText);
    const context = React.useContext(ThemeContext);
    const [orderCodeData, setOrderCodeData] = useState([]);
    const [massiveEditDialog, setMassiveEditDialog] = useState<boolean>(false);
    const [isEditingOrder, setIsEditingOrder] = useState<boolean>(false);
    let statusData: Array<any> = [];
    let currentTempName: string;
    let currentTempId: number = -1;
    let isRenderBegin: boolean = false;
    let orderCodeObj: any;
    let orderCodeElem: any;
    let tradeObj: any;
    let tradeElem: any;
    let pmIdElem: any;
    let pmIdObj: any;
    let statusElem: any;
    let statusObj: any;
    let pmTextElem: any;
    let pmTextObj: any;
    const getGlobalFilters = async () => {
        await getGlobalFilter('operation$status$isEnabled€1')
            .then((res) => {
                statusData = res.data;
            })
            .catch(() => {
                console.log('Error when get status');
            });
    };
    let buttonScheduler: ButtonPropsModel[] = [
        {
            click: async (args: any) => {
                await editOperations()
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                setHideSchedulerTimeDialog(false);
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];

    const editOperations = async () => {
        let datas = gridCPOp.current?.getSelectedRecords() || [];
        if (datas.length > 0) {
            datas.map((item: any) => {
                delete item.materialStatus;
                delete item.tradeDescription;
                delete item.label;
                delete item.commitFailedMessage;

                let date = dateTimePicker.value;
                if (date) {
                    item.scheduled_start_date = moment(date);
                }
            })
            const offsetDiff = serverOffsetMillis - localOffsetMillis;
            const adjustedDatas = getAdjustedDatas(datas, 'edit-button', offsetDiff, serverOffsetMillis);

            const uniqueAdjustedDatas = adjustedDatas.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => t.operationId === item.operationId)
            );
            await EditOperations(uniqueAdjustedDatas);
            setHideSchedulerTimeDialog(false);
            getBusinessLogic();
        }
    }
    let confirmSchedulerTime = (event: any) => {
        if (event.value) {
            const newDate = new Date(event.value);
            newDate.setHours(6, 0, 0, 0);
            setDefaultConfirmScheduleDate(newDate);
        }
    };
    const pmTextParams = {
        create: () => {
            pmTextElem = document.createElement('input');
            return pmTextElem;
        },
        destroy: () => {
            pmTextObj.destroy();
        },
        read: () => {
            return pmTextObj.value;
        },
        write: (args: any) => {
            pmTextObj = new TextBox({
                change: () => {
                },
                enabled: false,
                floatLabelType: 'Never',
                value: currentTempName,
            });
            pmTextObj.appendTo(pmTextElem);
        },
    };

    const tradeParams = {
        create: () => {
            tradeElem = document.createElement('input');
            return tradeElem;
        },
        destroy: () => {
            tradeObj.destroy();
        },
        read: () => {
            return tradeObj.text;
        },
        write: async (args: any) => {
            if (!tradeData || tradeData.length === 0) {
                await getTrade();
            }

            tradeObj = new DropDownList({
                change: () => {
                },
                dataSource: tradeData,
                fields: {text: 'trade_code', value: 'trade_id'},
                floatLabelType: 'Never',
                placeholder: 'Select a Trade',
                allowFiltering: true,
                text: args.rowData.tradeCode,
                value: args.rowData.tradeId,
            });
            tradeObj.appendTo(tradeElem);
        },
    };
    const pmIDParams = {
        create: () => {
            pmIdElem = document.createElement('input');
            return pmIdElem;
        },
        destroy: () => {
            pmIdObj.destroy();
        },
        read: () => {
            return pmIdObj?.value;
        },
        write: (args: any) => {
            pmIdObj = new TextBox({
                change: () => {
                },
                enabled: false,
                floatLabelType: 'Never',
                value: currentTempId.toString(),
            });
            pmIdObj.appendTo(pmIdElem);
        },
    };
    const statusParams = {
        create: () => {
            statusElem = document.createElement('input');
            return statusElem;
        },
        destroy: () => {
            statusObj.destroy();
        },
        read: () => {
            return statusObj.value;
        },
        write: (args: any) => {
            statusObj = new DropDownList({
                change: () => {
                },
                dataSource: statusData,
                fields: {value: 'value', text: 'alias'},
                placeholder: 'Select a status',
                enabled: true,
                showClearButton: true,
                filterBarPlaceholder: 'Search a status',
                floatLabelType: 'Never',
                allowFiltering: true,
                value: args.rowData.status_code,
            });
            statusObj.appendTo(statusElem);
        },
    };

    const handleToolbarClick = async (args: any) => {
        let datas: any = [];
        if (args.item.text === 'Copy') {
            const selectedRecords = gridOpTemplate.getSelectedRecords();
            if (selectedRecords.length > 0) {
                const currentRecords = Array.isArray(gridOpTemplate.dataSource) 
                ? [...gridOpTemplate.dataSource] 
                : [];
                const copiedRecord: any = {...selectedRecords[0]};
                const maxSequence = currentRecords.reduce((max, item) => {
                const seq = Number(item.operationSequence) || 0;
                return seq > max ? seq : max;
                }, 0);
                copiedRecord.operationSequence = maxSequence + 10;
                const maxId = currentRecords.reduce((max, item) => {
                     const currentId = Number(item.id) || 0;
                     return currentId > max ? currentId : max;
                }, 0);
                copiedRecord.id = maxId + 1;
                delete copiedRecord.operationId;

                if (Array.isArray(gridOpTemplate.dataSource)) {
                    datas = [...gridOpTemplate.dataSource, copiedRecord];
                }
                gridOpTemplate.dataSource = datas;
                gridOpTemplate.refresh();
            } else {
                Message.warning('Please select an operation to copy')
            }
        }
        if (args.item.id === 'save_changes') {
            const selectedRecords = gridOpTemplate.getSelectedRecords();
            if (Array.isArray(gridOpTemplate.getCurrentViewRecords())) {
                datas = gridOpTemplate.getCurrentViewRecords();
            }
            if (selectedRecords.length >= 0) {
                let isAppendable: boolean = true;
                const grouped = datas.reduce((acc: any, item: any) => {
                    if (!acc[item.orderCode]) {
                        acc[item.orderCode] = [];
                    }
                    acc[item.orderCode].push(item);
                    return acc;
                }, {});

                for (const order in grouped) {
                    const pmMap = new Map();
                    for (const item of grouped[order]) {
                        const sequence = item.operationSequence;

                    if (pmMap.has(sequence)) {
                            Message.error(
                                `The Operation Sequence ${sequence} is duplicated for ${item.orderCode}`
                            );
                            isAppendable = false;
                            break;
                        }
                
                        pmMap.set(sequence, item);
                    }
            
                    if (!isAppendable) break;
                }

                if (isAppendable) {
                    datas.map((item: any) => {
                        delete item.materialStatus;
                        delete item.order_status_code;
                        delete item.id;
                        delete item.ID;
                        delete item.commitFailedMessage;
                        item.required = item.required.toString();
                        item.estHours = item.estHours != null ? item.estHours.toString() : item.estHours;
                        item.required = item.required && item.required.toString();
                    });
                    try {
                        await EditOperations(datas).then(() => {
                            gridOpTemplate.setProperties({dataSource: datas}, true);
                            gridCPOp?.current?.dataBind();
                        });
                        Message.success('Success');
                        setShowOperationTemplateModal(false);
                        buildQuery();

                    } catch (err: any) {
                        if (err.response) {
                            Message.error(
                                err.response.data +
                                '\n' +
                                err.response.status +
                                '\n' +
                                err.response.headers
                            );
                        } else if (err.request) {
                            Message.error(err.request);
                        } else {
                            Message.error('Error: ' + err.message);
                        }
                    } finally {
                        loadingShow(false);
                    }
                }
            }
        }
    };
    const toolbarOptionsForDetail: any = [
        {
            text: 'Copy',
            tooltipText: 'Copy',
            prefixIcon: 'e-copy',
            id: 'copy',
        },
        {
            text: 'Save Changes',
            tooltipText: 'Save Changes',
            prefixIcon: 'e-save',
            id: 'save_changes',
        },
        //'Add',
        // 'Edit',
        //'Delete',
        //'Update',
        'Cancel',
    ];

    const getTrade = async () => {
        await getTrades().then((result) => {
            result.data.map((item: any) => {
                tradeData.push(item);
            });
        });
    };
    useEffect(() => {
        console.log("event: ", plan_id)
    })
    useEffect(() => {
        if (context.isClickedQuickLoad) {
            let datas = gridCPOp.current?.getSelectedRecords() || [];
            if (datas.length > 0) {
                const serverOffsetMillis = 60 * 1000 * gmt * (-60);

                const localOffset = new Date().getTimezoneOffset();
                const localOffsetMillis = 60 * 1000 * localOffset;

                const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;
                const editOperations = async () => {
                    datas.forEach((item: any) => {
                        delete item.materialStatus;
                        delete item.tradeDescription;
                        delete item.label;
                        delete item.plannedStartDate;
                        delete item.planned_end_date;
                        delete item.commitFailedMessage;

                        const date = context.quickScheduleDateOnLoad;
                        const timePart = moment(item.scheduled_start_date).format("HH:mm:ss");

                        if (typeof date === 'string' && !(date as string).includes(':')) {
                            const dateNew = moment(`${date}T${timePart}`);

                            item.scheduled_start_date = new Date(
                                dateNew.valueOf() + differenceOffsetMillis
                            ).toISOString();
                        }
                    });

                    await EditOperations(datas);
                    getBusinessLogic();
                };

                editOperations();
            }
        }
    }, [context.isClickedQuickLoad]);


    useEffect(() => {
        isRenderBegin = true;
        //getTrade();
        getGlobalFilters();

        return () => {
            isRenderBegin = false;
        };
    }, [currentTempId]);
    const revisionTemplate = (args: any) => {
        if (args.revision_code === 0) {
            return <span></span>;
        }

        return <span>{args.revision_alias}</span>;
    };
    const template = () => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignSelf: 'flex-end',
                    height: 25,
                }}
            >
                <TextBoxComponent
                    ref={(scope: TextBoxComponent) => (searchTextBox = scope)}
                    type={'text'}
                    id='work_operations_search'
                    autocomplete='off'
                    showClearButton
                    placeholder='Search'
                    value={searchText}
                    onChange={(args: any) => {
                        searchText = args.target.value;
                    }}
                />
                <div
                    style={{
                        borderRightColor: 'transparent',
                        borderTopColor: 'transparent',
                        borderBottomColor: 'transparent',
                    }}
                >
                    <BsSearch
                        color={context.isDarkMode ? '#eaeaea' : '#292525'}
                        className={'searchIcon'}
                        onClick={search}
                    />
                </div>
            </div>
        );
    };

    function getSecondNumber(sequence: string): number {
        const parts = sequence.split('-');
        const secondPart = parts[1]?.trim();
        return secondPart ? Number(secondPart) : NaN;
    }

    const shiftAssignment = () => {
        let selectedElement = gridCPOp.current?.getSelectedRecords() || [];
        if (
            dropDownListObjectShiftElment.value === undefined ||
            dropDownListObjectShiftElment.value === null
        ) {
            Message.error('You should select a shift');
            return;
        }
        if (selectedElement.length > 0) {
            const obj = [
                ...selectedElement.map((el: any) => {
                    if (dropDownListObjectShiftElment.value === -1) {
                         return {
                            operationId: el.operationId,
                            shift: null,
                            shiftId: null,
                            createdBy: all_information.user_id,
                        };
                    } else {
                        return {
                            operationId: el.operationId,
                            shift: dropDownListObjectShiftElment.text,
                            shiftId: dropDownListObjectShiftElment.value,
                            createdBy: all_information.user_id,
                        };
                    }
                }),
            ];

            EditOperations(obj)
                .then(() => {
                    Message.success('Success');
                    loadingShow(false);
                    buildQuery();
                    //getBusinessLogic();
                    setHideDeleteDialog(false);
                })
                .catch((err: any) => {
                    if (err.response) {
                        Message.error(
                            err.response.data +
                            '\n' +
                            err.response.status +
                            '\n' +
                            err.response.headers
                        );
                    } else if (err.request) {
                        Message.error(err.request);
                    } else {
                        Message.error('Error: ' + err.message);
                    }
                    loadingShow(false);
                });
        }
    };

    const onShiftActionComplete = (e: any) => {
        if (e.name === 'actionComplete' && e.result) {
            const data = e.result.result ? e.result.result : e.result;
            const exists = data.some((x: any) => x.rosterId === -1);
            if (!exists) {
                data.unshift({ rosterCode: '', rosterId: -1, description: '' });
            }
        }
    };

    const onTeamActionComplete = (e: any) => {
        if (e.name === 'actionComplete' && e.result) {
            const data = e.result.result ? e.result.result : e.result;
            const exists = data.some((x: any) => x.team_id === -1);
            if (!exists) {
                data.unshift({ team_code: '', team_id: -1 });
            }
        }
    };

    const teamAssignment = () => {
        let selectedElement = gridCPOp.current?.getSelectedRecords() || [];
        if (
            dropDownListObjectTeamElment.value === undefined ||
            dropDownListObjectTeamElment.value === null
        ) {
            Message.error('You should select a team');
            return;
        }
        if (selectedElement.length > 0) {
            const obj = [
                ...selectedElement.map((el: any) => {
                    if (dropDownListObjectTeamElment.value === -1) {
                        return {
                            operationId: el.operationId,
                            teamCode: null,
                            createdBy: all_information.user_id,
                        };
                    } else {
                        return {
                            operationId: el.operationId,
                            teamCode: dropDownListObjectTeamElment.text,
                            createdBy: all_information.user_id,
                        };
                    }
                }),
            ];

            EditOperations(obj)
                .then(() => {
                    Message.success('Success');
                    loadingShow(false);
                    getBusinessLogic();
                    setHideAssignTeamDialog(false);
                })
                .catch((err: any) => {
                    if (err.response) {
                        Message.error(
                            err.response.data +
                            '\n' +
                            err.response.status +
                            '\n' +
                            err.response.headers
                        );
                    } else if (err.request) {
                        Message.error(err.request);
                    } else {
                        Message.error('Error: ' + err.message);
                    }
                    loadingShow(false);
                });
        }
    };
    const assignButton = () => {
        return (
            <ButtonComponent
                onClick={() => {
                    let selectedElement = gridCPOp.current?.getSelectedRecords() || [];
                    if (selectedElement.length > 0) {
                        setHideDeleteDialog(true);
                    } else {
                        Message.error('Must selected a operation at least');
                    }
                }}
            >
                <MdAssignmentTurnedIn/> Shift Assign
            </ButtonComponent>
        );
    };

    const assignTeamButton = () => {
        return (
            <ButtonComponent
                onClick={() => {
                    let selectedElement = gridCPOp.current?.getSelectedRecords() || [];
                    if (selectedElement.length > 0) {
                        setHideAssignTeamDialog(true);
                    } else {
                        Message.error('Must selected a operation at least');
                    }
                }}
            >
                Team Assign
            </ButtonComponent>
        );
    };
    const priorityColorChip = () => {
        return (
            <div
                className='row md-6'
                style={{
                    alignSelf: 'end',
                    display: 'flex',
                    right: 220,
                }}
            >
                <ChipListComponent
                    id='chip-filter-cp'
                    selectedChips={selectedChipValues}
                    selection='Multiple'
                    click={isChipClicked2.bind(this)}
                >
                    <ChipsDirective>
                        {PriorityColorData.map((el: any, index: number) => {
                            return (
                                <ChipDirective
                                    text={`P${el.priority_code.trim()}`}
                                    cssClass={`e-chip-text${el.priority_code.trim()}`}
                                    key={index}
                                />
                            );
                        })}
                    </ChipsDirective>
                </ChipListComponent>
            </div>
        );
    };
    toolbarOptions = [
        {
            text: 'Commit',
            tooltipText: '',
            id: 'update_pronto_api',
            prefixIcon: 'e-check',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            text: 'Schedule',
            tooltipText: 'Scheduler',
            prefixIcon: 'e-timeline-month',
            id: 'scheduler',
        },
        {
            text: 'Commit OP',
            tooltipText: '',
            id: 'update_mex_workordertrade',
            prefixIcon: 'e-check',
            visible: ERP_TYPE !== erpTypeName ? false : true,
        },
        {
            text: 'Assign Workorders',
            tooltipText: 'Assign workorders into the plan.',
            prefixIcon: 'e-properties-1',
            id: 'assign_workorders',
        },
        'Edit',
        'Delete',
        // 'Update',
        // 'Cancel',
        {
            text: 'Refresh',
            tooltipText: 'Refresh',
            prefixIcon: 'e-repeat',
            id: 'refresh',
        },
        {
            text: 'Show Order',
            tooltipText: '',
            id: 'show_order',
        },
        // {
        //   text: 'Show Resources',
        //   tooltipText: '',
        //   id: 'show_resources',
        // },
        {
            text: 'Add Operation',
            tooltipText: '',
            id: 'add_operation',
        },
        {template: priorityColorChip.bind(this), align: 'Right'},
        'ColumnChooser',
        {template: assignButton.bind(this)},
        {template: assignTeamButton.bind(this), prefixIcon: 'e-people'},
        {
            text: 'Sync From ERP',
            tooltipText: '',
            id: 'sync_from_erp',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            text: 'Reset Data',
            tooltipText: '',
            id: 'reset_pronto_data',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {
            text: 'Get New Data',
            tooltipText: '',
            id: 'fetchRecords_from_pronto',
            visible: ERP_TYPE === erpTypeName ? false : true,
        },
        {template: template, align: 'Right'},
        {text: 'Excel Export', id: 'ExcelExport'},
        {
            text: 'Mass Edit',
            tooltipText: 'Mass Edit',
            id: 'super_schedule',
        },
    ];
    buttonShiftAssignment = [
        {
            click: () => {
                shiftAssignment();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                setHideDeleteDialog(false);
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    buttonTeamAssignment = [
        {
            click: () => {
                teamAssignment();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                setHideAssignTeamDialog(false);
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    const isChipClicked2 = (e: any) => {
        if (e.selected) {
            selectedChips.push(e.index + 1);
            selectedChipValues.push(e.index);
        } else {
            selectedChips.splice(selectedChips.indexOf(e.index + 1), 1);
            selectedChipValues.splice(selectedChipValues.indexOf(e.index), 1);
        }
        setTheSearchText(searchText);
        buildQuery();
    };
    const getBusinessLogic = async () => {
        //current_query = await applyTheRule('uw_operation', 'Cloud Planner');
        setTheSearchText(searchText);
        buildQuery();
    };
    const search = () => {
        if (searchText === '') {
            dispatch(setSearchCaseOp(''));
        }
        if (searchText !== '' || current_query !== '') {
            setTheSearchText(searchText);
            buildQuery();
        }
    };

    const buildQuery = (checkFilterParams : boolean = true) => {
        current_query = current_query.trimEnd();
        current_query = current_query.replace(theQueryPrioritys, '');
        current_query = current_query.replace(theQueryTeams, '');
        current_query = current_query.replace(theQueryShifts, '');
        current_query = current_query.replace(theQueryTrades, '');
        current_query = current_query.replace(theQueryOPStatus, '');
        current_query = current_query.replace(theQueryAsset, '');
        current_query = current_query.replace(theQueryParentAsset, '');
        current_query = current_query.replace(theQueryOutterAsset, '');
        current_query = current_query.replace(theQueryDate, '');
        current_query = current_query.replace(theQueryResp, '');
        current_query = current_query.replace(theQueryStatuses, '');
        current_query = current_query.replace(theQueryType, '');
        current_query = current_query.replace(theQueryHasProblem, '');
        current_query = current_query.replace(theQuerySearch, '');
        current_query = current_query.replace(theQueryPlanId, '');
        current_query = current_query.replace(theQueryReference, '');
        current_query = current_query.replace(theQueryWorkOrderCode, '');
        current_query = current_query.replace(theQueryScheduleNumber, '');
        current_query = current_query.replace(theQueryDepartment, '');
        current_query = current_query.replace(theQuerySection, '');
        current_query = current_query.replace(theQueryProntoReference, '');
        current_query = current_query.replace(theQueryHoldReason, '');
        current_query = current_query.replace(theQueryRevisionCode, '');

        var o_asset_code = outter_asset_code;
        theQueryDepartment = '';
        theQuerySection = '';
        theQueryTeams = '';
        theQueryShifts = '';
        theQueryTrades = '';

        theQueryProntoReference = '';
        theQueryHoldReason = '';
        theQueryRevisionCode = '';
        theQueryPrioritys = '';
        theQueryStatuses = '';
        theQueryAsset = '';
        theQueryParentAsset = '';
        theQueryResp = '';
        theQueryType = '';
        theQueryHasProblem = '';
        theQueryDate = '';
        theQuerySearch = '';
        theQueryOutterAsset = '';
        theQueryReference = '';
        theQueryWorkOrderCode = '';
        theQueryScheduleNumber = '';

        var thePrioritysMerged = selectedChips.concat(priorityFMSComValue);
        var thePurePrioritys = [...new Set(thePrioritysMerged)];
        var thePrioritys = thePurePrioritys?.toString();

        var theDepartment = departmentFMSCom?.value?.toString();
        var theSection = sectionFMSCom?.value?.toString();
        var theProntoReference = prontoReferenceFMSCom?.value?.toString();
        var theHoldReason = holdReasonFMSCom?.value?.toString();
        var theRevisionCode = revisionCodeFMSCom?.value?.toString();

        var theStatuses = statusFMSCom?.value?.toString();

        var theTeams = teamFMSCom?.value?.toString();
        var theShifts = shiftFMSCom?.value?.toString();
        var theTrades = tradeFMSCom?.value?.toString();
        var theOPStatus = OPStatusFMSCom?.value?.toString();

        var theTypes = typeFMSCom?.value?.toString();
        var theHasproblem = hasProblem?.value?.toString();
        var theResp = respFMSCom?.value?.toString();

        var theReference = referenceFMSCom?.value?.toString();
        var theworkorderCode = workorderCodeFMSCom?.value?.toString();
        var theScheduleNumber = ScheduleNumberFMSCom?.value?.toString();

        var theDate = schdeduleStartDateVal;
        var thePlannedDate = plannedStartDateVal;
        var theAssets = assetFMSCom?.value?.toString();
        var theparentAssets = parentAssetFMSCom?.value?.toString();
        if (checkFilterParams ) {
            if (theScheduleNumber === '' || theScheduleNumber === undefined) {
                var theScheduleNumberFromLocalStorage = localStorage.getItem(
                    'textboxPMSchedulerNumberTextComponentOP'
                );
                if (theScheduleNumberFromLocalStorage) {
                    theScheduleNumber = extractNumbers(theScheduleNumberFromLocalStorage);
                }
            }

            if (theScheduleNumber !== '' && theScheduleNumber !== undefined) {
                if (current_query !== '') {
                    theQueryScheduleNumber = addToQuery(
                        'pm_schedule_number',
                        'in',
                        'andWhere',
                        theScheduleNumber?.toString()
                    );
                } else {
                    theQueryScheduleNumber = addToQuery(
                        'pm_schedule_number',
                        'in',
                        'where',
                        theScheduleNumber?.toString()
                    );
                }
                current_query += theQueryScheduleNumber;
            }

            if (theworkorderCode === '' || theworkorderCode === undefined) {
                var theScheduleWorkorderFromLocalStorage = localStorage.getItem(
                    'textboxWorkOrderTextBoxOP'
                );
                if (theScheduleWorkorderFromLocalStorage) {
                    theworkorderCode = extractNumbers(
                        theScheduleWorkorderFromLocalStorage
                    );
                }
            }

            if (theworkorderCode !== '' && theworkorderCode !== undefined) {
                if (current_query !== '') {
                    theQueryWorkOrderCode = addToQuery(
                        'order_code',
                        'in',
                        'andWhere',
                        theworkorderCode?.toString()
                    );
                } else {
                    theQueryWorkOrderCode = addToQuery(
                        'order_code',
                        'in',
                        'where',
                        theworkorderCode?.toString()
                    );
                }
                current_query += theQueryWorkOrderCode;
            }

            if (theDepartment == '' || theDepartment == undefined) {
                var thDepartmentFromLocalStorage = localStorage.getItem(
                    'multiselectDepartmentordersFilterMultiPriorityOP'
                );
                var thDepartmentFromLocalStorageString = extractCharacters(
                    thDepartmentFromLocalStorage
                ).join(',');
                theDepartment = thDepartmentFromLocalStorageString;
            }

            if (theDepartment !== '' && theDepartment !== undefined) {
                if (current_query !== '') {
                    theQueryDepartment = addToQuery(
                        'department_id',
                        'in',
                        'andWhere',
                        theDepartment?.toString()
                    );
                } else {
                    theQueryDepartment = addToQuery(
                        'department_id',
                        'in',
                        'where',
                        theDepartment?.toString()
                    );
                }
                current_query += theQueryDepartment;
            }
            if (theSection !== '' && theSection !== undefined) {
                if (current_query !== '') {
                    theQuerySection = addToQuery(
                        'order_section_code',
                        'in',
                        'andWhere',
                        theSection?.toString()
                    );
                } else {
                    theQuerySection = addToQuery(
                        'order_section_code',
                        'in',
                        'where',
                        theSection?.toString()
                    );
                }
                current_query += theQuerySection;
            }
            if (theProntoReference !== '' && theProntoReference !== undefined) {
                if (current_query !== '') {
                    theQueryProntoReference = addToQuery(
                        'site_details_1',
                        'in',
                        'andWhere',
                        theProntoReference?.toString()
                    );
                } else {
                    theQueryProntoReference = addToQuery(
                        'site_details_1',
                        'in',
                        'where',
                        theProntoReference?.toString()
                    );
                }
                current_query += theQueryProntoReference;
            }
            if (theHoldReason !== '' && theProntoReference !== undefined) {
                if (current_query !== '') {
                    theQueryHoldReason = addToQuery(
                        'reason',
                        'in',
                        'andWhere',
                        theHoldReason!.toString()
                    );
                } else {
                    theQueryHoldReason = addToQuery(
                        'reason',
                        'in',
                        'where',
                        theHoldReason!.toString()
                    );
                }
                current_query += theQueryHoldReason;
            }
            if (theRevisionCode !== '' && theProntoReference !== undefined) {
                if (current_query !== '') {
                    theQueryRevisionCode = addToQuery(
                        'revision_code',
                        'in',
                        'andWhere',
                        theRevisionCode!.toString()
                    );
                } else {
                    theQueryRevisionCode = addToQuery(
                        'revision_code',
                        'in',
                        'where',
                        theRevisionCode!.toString()
                    );
                }
                current_query += theQueryRevisionCode;
            }
            if (thePrioritys == '' || thePrioritys == undefined) {
                var thPriorityFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiPriorityOP'
                );
                var thPriorityFromLocalStorageString = extractCharacters(
                    thPriorityFromLocalStorage
                ).join(',');
                thePrioritys = thPriorityFromLocalStorageString;
            }
            if (thePrioritys !== '' && thePrioritys !== undefined) {
                if (current_query !== '') {
                    theQueryPrioritys = addToQuery(
                        'priority_code',
                        'in',
                        'andWhere',
                        thePrioritys?.toString()
                    );
                } else {
                    theQueryPrioritys = addToQuery(
                        'priority_code',
                        'in',
                        'where',
                        thePrioritys?.toString()
                    );
                }
                current_query += theQueryPrioritys;
            }

            if (theTeams == '' || theTeams == undefined) {
                var thTeamFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiTeamOP'
                );
                var thTeamFromLocalStorageString = extractCharacters(
                    thTeamFromLocalStorage
                ).join(',');
                theTeams = thTeamFromLocalStorageString;
            }
            if (theTeams !== '' && theTeams !== undefined) {
                if (current_query !== '') {
                    theQueryTeams = addToQuery(
                        'team_code',
                        'in',
                        'andWhere',
                        theTeams?.toString()
                    );
                } else {
                    theQueryTeams = addToQuery(
                        'team_code',
                        'in',
                        'where',
                        theTeams?.toString()
                    );
                }
                current_query += theQueryTeams;
            }

            if (theShifts == '' || theShifts == undefined) {
                var thShiftFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiShiftOP'
                );
                var thShiftFromLocalStorageString = extractCharacters(
                    thShiftFromLocalStorage
                ).join(',');
                theShifts = thShiftFromLocalStorageString;
            }
            if (theShifts !== '' && theShifts !== undefined) {
                if (current_query !== '') {
                    theQueryShifts = addToQuery(
                        'shift',
                        'in',
                        'andWhere',
                        theShifts?.toString()
                    );
                } else {
                    theQueryShifts = addToQuery(
                        'shift',
                        'in',
                        'where',
                        theShifts?.toString()
                    );
                }
                current_query += theQueryShifts;
            }
            if (theTrades == '' || theTrades == undefined) {
                var thTradeFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiTradeOP'
                );
                var thTradeFromLocalStorageString = extractCharacters(
                    thTradeFromLocalStorage
                ).join(',');
                theTrades = thTradeFromLocalStorageString;
            }
            if (theTrades !== '' && theTrades !== undefined) {
                if (current_query !== '') {
                    theQueryTrades = addToQuery(
                        'tradeCode',
                        'in',
                        'andWhere',
                        theTrades?.toString()
                    );
                } else {
                    theQueryTrades = addToQuery(
                        'tradeCode',
                        'in',
                        'where',
                        theTrades?.toString()
                    );
                }
                current_query += theQueryTrades;
            }
            if (theOPStatus == '' || theOPStatus == undefined) {
                var thOPStatusFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiOPStatusOP'
                );
                var thOPStatusFromLocalStorageString = extractCharacters(
                    thOPStatusFromLocalStorage
                ).join(',');
                theOPStatus = thOPStatusFromLocalStorageString;
            }
            if (theOPStatus !== '' && theOPStatus !== undefined) {
                if (current_query !== '') {
                    theQueryOPStatus = addToQuery(
                        'status',
                        'in',
                        'andWhere',
                        theOPStatus?.toString()
                    );
                } else {
                    theQueryOPStatus = addToQuery(
                        'status',
                        'in',
                        'where',
                        theOPStatus?.toString()
                    );
                }
                current_query += theQueryOPStatus;
            }

            if (theStatuses == '' || theStatuses == undefined) {
                var thStatusFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiStatusOP'
                );
                var thStatusFromLocalStorageString = extractCharacters(
                    thStatusFromLocalStorage
                ).join(',');
                theStatuses = thStatusFromLocalStorageString;
            }
            if (erpTypeName === ERP_TYPE) {
                if (theStatuses !== '' && theStatuses !== undefined) {
                    if (current_query !== '') {
                        theQueryStatuses = addToQuery(
                            'status_id',
                            'in',
                            'andWhere',
                            theStatuses?.toString()
                        );
                    } else {
                        theQueryStatuses = addToQuery(
                            'status_id',
                            'in',
                            'where',
                            theStatuses?.toString()
                        );
                    }
                    current_query += theQueryStatuses;
                }
            } else {
                if (theStatuses !== '' && theStatuses !== undefined) {
                    if (current_query !== '') {
                        theQueryStatuses = addToQuery(
                            'status_code',
                            'in',
                            'andWhere',
                            theStatuses?.toString()
                        );
                    } else {
                        theQueryStatuses = addToQuery(
                            'status_code',
                            'in',
                            'where',
                            theStatuses?.toString()
                        );
                    }
                    current_query += theQueryStatuses;
                }
            }

            if (theAssets === '' || theAssets === undefined) {
                var theAssetFromLocalStorage = localStorage.getItem(
                    'textboxAssetTextBoxOP'
                );
                if (theAssetFromLocalStorage) {
                    theAssets = extractStringValue(theAssetFromLocalStorage);
                }
            }
            if (theAssets !== '' && theAssets !== undefined) {
                if (current_query !== '') {
                    theQueryAsset = addToQuery(
                        'asset_code',
                        'in',
                        'andWhere',
                        theAssets?.toString()
                    );
                } else {
                    theQueryAsset = addToQuery(
                        'asset_code',
                        'in',
                        'where',
                        theAssets?.toString()
                    );
                }
                current_query += theQueryAsset;
            }

            if (theparentAssets === '' || theparentAssets === undefined) {
                var theParentAssetFromLocalStorage = localStorage.getItem(
                    'textboxParentAssetTextBoxOP'
                );
                if (theParentAssetFromLocalStorage) {
                    theparentAssets = extractStringValue(theParentAssetFromLocalStorage);
                }
            }
            if (theparentAssets !== '' && theparentAssets !== undefined) {
                if (current_query !== '') {
                    theQueryParentAsset = addToQuery(
                        'asset_code_parent',
                        'in',
                        'andWhere',
                        theparentAssets?.toString()
                    );
                } else {
                    theQueryParentAsset = addToQuery(
                        'asset_code_parent',
                        'in',
                        'where',
                        theparentAssets?.toString()
                    );
                }
                current_query += theQueryParentAsset;
            }
            if (theTypes == '' || theTypes == undefined) {
                var theTypeFromLocalStorage = localStorage.getItem(
                    'multiselectoperationFilterMultiTypeOP'
                );
                var theTypeFromLocalStorageString = extractCharacters(
                    theTypeFromLocalStorage
                ).join(',');
                theTypes = theTypeFromLocalStorageString;
            }
            if (erpTypeName === ERP_TYPE) {
                if (theTypes !== '' && theTypes !== undefined) {
                    if (current_query !== '') {
                        theQueryType = addToQuery(
                            'type_id',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    } else {
                        theQueryType = addToQuery(
                            'type_id',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    }

                    current_query += theQueryType;
                }
            } else {
                if (theTypes !== '' && theTypes !== undefined) {
                    if (current_query !== '') {
                        theQueryType = addToQuery(
                            'type_code',
                            'in',
                            'andWhere',
                            theTypes?.toString()
                        );
                    } else {
                        theQueryType = addToQuery(
                            'type_code',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    }
                    current_query += theQueryType;
                }
            }

            if (theResp !== '' && theResp !== undefined) {
                if (current_query !== '') {
                    theQueryResp = addToQuery(
                        'order_resp_code',
                        'in',
                        'andWhere',
                        theResp?.toString()
                    );
                } else {
                    theQueryResp = addToQuery(
                        'order_resp_code',
                        'in',
                        'where',
                        theResp?.toString()
                    );
                }
                current_query += theQueryResp;
            }
            if (theReference === '' || theReference === undefined) {
                var theReferenceFromLocalStorage = localStorage.getItem(
                    'textboxReferenceTextBoxOP'
                );
                if (theReferenceFromLocalStorage) {
                    theReference = extractStringValue(theReferenceFromLocalStorage);
                }
            }

            if (theReference !== '' && theReference !== undefined) {
                if (current_query !== '') {
                    theQueryReference = addToQuery(
                        'site_details_1',
                        'in',
                        'andWhere',
                        theReference?.toString()
                    );
                } else {
                    theQueryReference = addToQuery(
                        'site_details_1',
                        'in',
                        'where',
                        theReference?.toString()
                    );
                }
                current_query += theQueryReference;
            }
            if (theDate == '' || theDate == undefined) {
                var theScheduleStartDateFromLocalStorage = localStorage.getItem(
                    'daterangepickerScheduleStartDateFilterOP'
                );
                if (theScheduleStartDateFromLocalStorage) {
                    const parsedData = JSON.parse(theScheduleStartDateFromLocalStorage);
                    if (parsedData.startDate && parsedData.endDate && parsedData.value) {
                        theDate = convertToDate({
                            startDate: parsedData.startDate,
                            endDate: parsedData.endDate,
                            value: parsedData.value,
                        });
                    }
                }
            }
            if (theDate !== '' && theDate && theDate !== undefined) {
                if (theDate.length > 0) {
                    if (current_query !== '') {
                        // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
                        // var end_date = moment(theDate[1]).format('yyyy-MM-DD');
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(theDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(theDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(theDate[0]).format('yyyy-MM-DD');
                            end_date = moment(theDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'scheduled_start_date',
                            '>=',
                            'andWhere',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'scheduled_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    } else {
                        // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
                        // var end_date = moment(theDate[1]).format('yyyy-MM-DD');
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(theDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(theDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(theDate[0]).format('yyyy-MM-DD');
                            end_date = moment(theDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'scheduled_start_date',
                            '>=',
                            'where',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'scheduled_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    }
                    current_query += theQueryDate;
                }
            }

            if (thePlannedDate == '' || thePlannedDate == undefined) {
                var thePlannedStartDateFromLocalStorage = localStorage.getItem(
                    'daterangepickerPlannedStartDateFilterOP'
                );
                if (thePlannedStartDateFromLocalStorage) {
                    const parsedData = JSON.parse(thePlannedStartDateFromLocalStorage);
                    if (parsedData.startDate && parsedData.endDate && parsedData.value) {
                        thePlannedDate = convertToDate({
                            startDate: parsedData.startDate,
                            endDate: parsedData.endDate,
                            value: parsedData.value,
                        });
                    }
                }
            }
            if (thePlannedDate !== '' && thePlannedDate && thePlannedDate !== undefined) {
                if (thePlannedDate.length > 0) {
                    if (current_query !== '') {
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(thePlannedDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(thePlannedDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(thePlannedDate[0]).format('yyyy-MM-DD');
                            end_date = moment(thePlannedDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'planned_start_date',
                            '>=',
                            'andWhere',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'planned_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    } else {
                        var start_date: string;
                        var end_date: string;
                        if (ERP_TYPE === erpTypeName) {
                            start_date = new Date(
                                new Date(thePlannedDate[0]).getTime() -
                                600 * 60 * 1000 -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();

                            end_date = new Date(
                                new Date(thePlannedDate[1].setHours(13, 59, 59)).getTime() -
                                new Date().getTimezoneOffset() * 60 * 1000
                            ).toISOString();
                        } else {
                            start_date = moment(thePlannedDate[0]).format('yyyy-MM-DD');
                            end_date = moment(thePlannedDate[1]).format('yyyy-MM-DD') + 'T23:59:59.000Z';
                        }

                        theQueryDate = addToQuery(
                            'planned_start_date',
                            '>=',
                            'where',
                            start_date
                        );
                        theQueryDate += addToQuery(
                            'planned_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    }
                    current_query += theQueryDate;
                }
            }

            if (o_asset_code !== '' && o_asset_code !== undefined) {
                if (current_query !== '') {
                    theQueryOutterAsset = addToQuery(
                        'asset_code',
                        'in',
                        'andWhere',
                        o_asset_code.trim()
                    );
                } else {
                    theQueryOutterAsset = addToQuery(
                        'asset_code',
                        'in',
                        'where',
                        o_asset_code.trim()
                    );
                }
                current_query += theQueryOutterAsset;
            }

            if (theHasproblem == '' || theHasproblem == undefined) {
                var theHasproblemfromLocalStorage = localStorage.getItem(
                    'multiselecthasProblemFilterMultiOP'
                );
                var theHasproblemfromLocalStorageString = extractCharacters(
                    theHasproblemfromLocalStorage
                ).join(',');
                theHasproblem = theHasproblemfromLocalStorageString;
            }

            if (theHasproblem !== '' && theHasproblem !== undefined) {
                if (current_query !== '') {
                    theQueryHasProblem = addToQuery(
                        'has_operation',
                        'in',
                        'andWhere',
                        theHasproblem?.toString()
                    );
                } else {
                    theQueryHasProblem = addToQuery(
                        'has_operation',
                        'in',
                        'where',
                        theHasproblem?.toString()
                    );
                }
                current_query += theQueryHasProblem;
            }
        }
        if (reduxSearchS.planId !== 0) {
            if (current_query !== '') {
                theQueryPlanId = addToQuery(
                    'ID',
                    '=',
                    'andWhere',
                    reduxSearchS.planId?.toString()
                );
            } else {
                theQueryPlanId = addToQuery(
                    'ID',
                    '=',
                    'where',
                    reduxSearchS.planId?.toString()
                );
            }
            current_query += theQueryPlanId;
        }
        if (
            theSearchText &&
            theSearchText !== '' &&
            !theSearchText?.includes('@')
        ) {
            theQuerySearch = '$' + theSearchText;
            current_query = current_query + theQuerySearch;
        }
        // if (clearRequest) {
        //   model = [];
        // }
        model = [];
        init_query = current_page_range + '$' + current_query;
        getTableData(current_page_range + '$' + current_query, false, model);
        dispatch(
            setIsPlanSelected({
                isOpPlanSelected: false,
                isOrderPlanSelected: reduxSearchS.isOrderPlanSelected,
                searchCaseOperation: '',
                planId: reduxSearchS.planId,
            })
        );
        dispatch(setSearchCaseOp(''));
        const filterParts = [
            theQueryPrioritys,
            theQueryTeams,
            theQueryShifts,
            theQueryTrades,
            theQueryOPStatus,
            theQueryDepartment,
            theQuerySection,
            theQueryProntoReference,
            theQueryHoldReason,
            theQueryRevisionCode,
            theQueryStatuses,
            theQueryAsset,
            theQueryParentAsset,
            theQueryOutterAsset,
            theQueryType,
            theQueryHasProblem,
            theQueryResp,
            theQueryDate,
            theQueryReference,
            theQueryWorkOrderCode,
            theQueryScheduleNumber
        ];

        const filterActive = filterParts.some(q => q && q.trim() !== "");

        setIsFilterActive(filterActive);
        localStorage.setItem("isFilterActive", JSON.stringify(filterActive));

    };
    // const addToQuery = (
    //   field: string,
    //   c: string,
    //   type: string,
    //   v: string,
    //   the_query: string
    // ) => {
    //   the_query = JSON.stringify({
    //     f: field,
    //     c: c,
    //     t: type,
    //     v: v,
    //   });
    //   the_query += '?';
    //   current_query += the_query;
    //   return the_query;
    // };
    const addToQuery = (
        field: string,
        c: string,
        type: string,
        v: string
    ) => {
        let the_current_query: string;
        the_current_query = JSON.stringify({
            f: field,
            c: c,
            t: type,
            v: v.replaceAll(`'`, ''),
        });
        the_current_query += '?';
        return the_current_query;
    };

    const getTableData = async (
        range: string,
        isFromPagging: boolean,
        theModel: Array<any>
    ) => {
        loadingShow(true, 'Loading');
        setData([]);

        let trades = await getTrades();
        trades.data.forEach((item: any) => {
            tradeData.push(item);
        });

        await getOperations(range)
            .then((result) => {
                loadingShow(false);
                if (result.data.length === 0 && isFromPagging) {
                    current_page--;
                }
                result.data.map((res: any) => {
                    res.scheduled_start_date = moment
                        .utc(res.scheduled_start_date)
                        .tz('UTC')
                        .format('YYYY-MM-DD HH:mm:ss');
                    res.scheduled_end_date = moment
                        .utc(res.scheduled_end_date)
                        .tz('UTC')
                        .format('YYYY-MM-DD HH:mm:ss');
                    res.plannedStartDate = moment
                        .utc(res.plannedStartDate)
                        .format('YYYY-MM-DD HH:mm:ss');
                    res.planned_end_date = moment
                        .utc(res.planned_end_date)
                        .format('YYYY-MM-DD HH:mm:ss');
                    for (var i = 0; i < Object.keys(res).length; i++) {
                        if (
                            res[Object.keys(res)[i]] !== null &&
                            typeof res[Object.keys(res)[i]] !== 'number' &&
                            typeof res[Object.keys(res)[i]] !== 'boolean'
                        ) {
                            res[Object.keys(res)[i]] = res[Object.keys(res)[i]]?.trim();
                        }
                    }
                    theModel.push({
                        ...res,
                    });
                });
                if (gridCPOp.current) {
                    gridCPOp.current.dataSource = model;
                    gridCPOp.current?.refresh();
                }

                trades.data.map((eachtrade: any) => {
                    model.map((eachmodel) => {
                        if (eachtrade.trade_code === eachmodel.tradeCode) {
                            eachmodel.tradeDescription = eachtrade.description;
                            eachmodel.label =
                                eachtrade.trade_code + ' | ' + eachtrade.description;
                        }
                    });
                });
                setData(model);
            })
            .catch((er) => {
                loadingShow(false);
                Message.error('Error occured while gettig data');
                if (er.response) {
                    Message.error(
                        er.response.data +
                        '\n' +
                        er.response.status +
                        '\n' +
                        er.response.headers
                    );
                } else if (er.request) {
                    Message.error(er.request);
                } else {
                    Message.error('Error: ' + er.message);
                }
                Message.error(er.config);
            });
    };

    const begin = (args: any) => {
        if (args.requestType === 'paging') {
            if (args.currentPage > args.previousPage) {
                let padeDiff = args.currentPage - args.previousPage;
                current_page += padeDiff;
                if (args.currentPage >= current_page) {
                    var pS = gridCPOp.current?.pageSettings.pageSize;
                    var s_inx = (current_page - 1) * Number(pS) + 1;
                    var e_inx = s_inx + (Number(pS) - 1);
                    current_page_range = s_inx + '$' + e_inx;
                    //buildQuery(false, searchText);
                    setTheSearchText(searchText);
                    buildQuery();
                }
            } else if (args.currentPage === args.previousPage) {
                pS = gridCPOp.current?.pageSettings.pageSize;
                var last_page = model.length / Number(pS);
                current_page = last_page;
            }
        }
        if (args.action === 'edit') {
            if (args.data) {
            
                const matchedTrade = tradeData.find(
                    (t: any) => t.trade_code === args.data.tradeCode
                );
                if (matchedTrade) {
                    args.data.tradeId = matchedTrade.trade_id;
                    args.data.tradeTypeId = matchedTrade.trade_type_id;
                }  
                
                const { commitFailedMessage,
                    scheduled_start_date, 
                    scheduled_end_date,
                    plannedStartDate,
                    planned_end_date, 
                    ...payload 
                } = args.data;
                SavePointEdit(payload); 
            }
        }
        if (args.action === 'add') {
            SavePointAdd(args.data);
        }
        if (args.requestType === 'delete') {
            SavePointDelete(args.data);
        }
    };

    const SavePointAdd = (data: any) => {
        data.required = data.required.toString();
        AddOperations(data)
            .then(() => {
                Message.success('Success');
                loadingShow(false);
                setTheSearchText(searchText);
                buildQuery();
            })
            .catch((err: any) => {
                if (err.response) {
                    Message.error(
                        err.response.data +
                        '\n' +
                        err.response.status +
                        '\n' +
                        err.response.headers
                    );
                } else if (err.request) {
                    Message.error(err.request);
                } else {
                    Message.error('Error: ' + err.message);
                }
                loadingShow(false);
            });
    };
    const SavePointDelete = (data: any) => {
        DeleteOperations(data)
            .then(() => {
                Message.success('Success');
                loadingShow(false);
                setTheSearchText(searchText);
                buildQuery();
            })
            .catch((err: any) => {
                if (err.response) {
                    Message.error(
                        err.response.data +
                        '\n' +
                        err.response.status +
                        '\n' +
                        err.response.headers
                    );
                } else if (err.request) {
                    Message.error(err.request);
                } else {
                    Message.error('Error: ' + err.message);
                }
                loadingShow(false);
            });
    };
    const getColor = async () => {
        let theData = await getPriority();
        setPriorityColorData(theData);
    };

    const orderCodeTemplate = (args: any) => {
        const data = args;
        const orderCode = data.orderCode;

        let tooltipText = '';
        if (data.commitFailedMessage) {
            tooltipText = data.commitFailedMessage.replace(new RegExp('^' + orderCode), '').trim();
        }
        return (
            <span
                className={`order-code-cell ${data?.commitFailedMessage ? 'error' : ''}`}
                title={tooltipText}
            >
            {orderCode}
        </span>
        );
    };
    const priorityColor = (args: any) => {
        let color = PriorityColorData.find(
            (x: any) => x.priority_code?.trim() === args?.priority?.trim()
        )?.priority_color;
        return (
            <div
                style={{
                    backgroundColor: color,
                    borderRadius: 7,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <span>{args.priority}</span>
            </div>
        );
    };

    const operationSequenceTemplate = (data: any): JSX.Element => {
        return (
            <span>
        <span>
          {data.pm_id != null ? data.pm_id + ' - ' : ''}
            {data.operationSequence}
        </span>
      </span>
        );
    };
    const itemTemplateShiftColor = (data: any): JSX.Element => {
        return (
            <span>
        <span
            id='exceptiontColor'
            style={{backgroundColor: data.rostercolor}}
        ></span>
        <span>{data.rosterCode + ' - ' + data.description}</span>
      </span>
        );
    };
    const materialColor = (args: any) => {
        return (
            <div
                style={{
                    backgroundColor: args.materialStatus,
                    borderRadius: 7,
                    width: '20px',
                    height: '20px',
                }}
            >
                <span> </span>
            </div>
        );
    };
    const contextMenuClick = (args: any) => {
        if (args.item.id === 'materials') {
        }
    };
    const actionComplete = (args: any) => {
        if (args.requestType == 'filterafteropen') {
            if (args.filterModel.dlgDiv.querySelector('.e-autocomplete')) {
                args.filterModel.dlgDiv.querySelector(
                    '.e-autocomplete'
                ).ej2_instances[0].autofill = false;
            }
        }
    };
    const clearFilter = () => {
        setIsFilterActive(false);
        localStorage.setItem('isFilterActive', JSON.stringify(false));
        departmentFMSCom.value = [];
        sectionFMSCom.value = [];
        prontoReferenceFMSCom.value = [];
        holdReasonFMSCom.value = [];
        revisionCodeFMSCom.value = [];
        workorderCodeFMSCom.value = '';
        statusFMSCom.value = [];
        teamFMSCom.value = [];
        shiftFMSCom.value = [];
        tradeFMSCom.value = [];
        OPStatusFMSCom.value = [];
        referenceFMSCom.value = '';
        assetFMSCom.value = '';
        parentAssetFMSCom.value = '';
        typeFMSCom.value = [];
        hasProblem.value = [];
        respFMSCom.value = [];
        priorityFMSCom.value = [];
        ScheduleNumberFMSCom.value = '';
        if (startDateFMSCom) {
            startDateFMSCom.value = '';
        }
        if (plannedStartDateFMSCom) {
            plannedStartDateFMSCom.value = '';
        }
        schdeduleStartDateVal = '';
        plannedStartDateVal = '';
        ScheduleNumberFMSComValue = '';
        //chips.selectedChips = [];
        priorityFMSComValue = [];
        statusFMSComValue = [];
        teamFMSComValue = [];
        shiftFMSComValue = [];
        tradeFMSComValue = [];
        OPStatusFMSComValue = [];
        departmentFMSComValue = [];

        hasProblemValue = [];
        typeFMSComValue = [];
        respFMSComValue = [];

        // referenceFMSComValue = '';
        setreferenceFMSComValue('');
        workorderCodeFMSComValue = '';
        parentAssetFMSComValue = '';

        if (current_query != '') {
            setTheSearchText('');
            current_query = '';
            if (reduxSearchS.planId !== 0) {
                if (current_query !== '') {
                    theQueryPlanId = addToQuery(
                        'ID',
                        '=',
                        'andWhere',
                        reduxSearchS.planId?.toString()
                    );
                } else {
                    theQueryPlanId = addToQuery(
                        'ID',
                        '=',
                        'where',
                        reduxSearchS.planId?.toString()
                    );
                }
                current_query += theQueryPlanId;
            }
            model = [];
            init_query = current_page_range + '$' + current_query;
            getTableData(current_page_range + '$' + current_query, false, model);
        }
    };

    const FilterPrio = () => {
        buildQuery();
    };
    const StatusMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        statusFMSCom = scope;
                    }}
                    field={{value: 'value', text: 'alias'}}
                    id='ordersFilterMultiStatusOP'
                    url='global-filter?where=workorders$status$isEnabled€1'
                    placeHolder='WO Status'
                    value={statusFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiStatusOP',
                                '{"value":[]}'
                            );
                        }
                        statusFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };

    const TeamMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        teamFMSCom = scope;
                    }}
                    field={{value: 'team_code', text: 'team_code'}}
                    id='ordersFilterMultiTeamOP'
                    url='team'
                    placeHolder='Select a Team'
                    value={teamFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiTeamOP',
                                '{"value":[]}'
                            );
                        }
                        teamFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const ShiftMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        shiftFMSCom = scope;
                    }}
                    field={{value: 'rosterCode', text: 'rosterCode'}}
                    id='ordersFilterMultiShiftOP'
                    url='shift/Shift/'
                    placeHolder='Select a Shift'
                    value={shiftFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiShiftOP',
                                '{"value":[]}'
                            );
                        }
                        shiftFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };

    const TradeMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        tradeFMSCom = scope;
                    }}
                    field={{value: 'trade_code', text: 'label'}}
                    id='ordersFilterMultiTradeOP'
                    url='trade'
                    placeHolder='Select a Trade'
                    value={tradeFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiTradeOP',
                                '{"value":[]}'
                            );
                        }
                        tradeFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };

    const OPStatusMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        OPStatusFMSCom = scope;
                    }}
                    field={{value: 'value', text: 'alias'}}
                    id='ordersFilterMultiOPStatusOP'
                    url='global-filter?where=operation$status$isEnabled€1'
                    placeHolder='OP Status'
                    value={OPStatusFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiOPStatusOP',
                                '{"value":[]}'
                            );
                        }
                        OPStatusFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };


    const PriorityMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        priorityFMSCom = scope;
                    }}
                    field={{value: 'value', text: 'alias'}}
                    id='ordersFilterMultiPriorityOP'
                    url='global-filter?where=workorders$priority$isEnabled€1'
                    placeHolder='Select a Priority'
                    value={priorityFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiPriorityOP',
                                '{"value":[]}'
                            );
                        }
                        priorityFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const ScheduleNumberComponent = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            ScheduleNumberFMSCom = scope;
                        }}
                        autocomplete='off'
                        id='PMSchedulerNumberTextComponentOP'
                        showClearButton
                        placeholder='PM Schedule Number'
                        value={ScheduleNumberFMSComValue}
                        enablePersistence={true}
                        onChange={(args: any) => {
                            ScheduleNumberFMSComValue = args.target.value;
                        }}
                    />
                )}
            </div>
        );
    };
    const DepartmentFilterInput = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        departmentFMSCom = scope;
                    }}
                    field={{value: 'value', text: 'alias'}}
                    id='DepartmentordersFilterMultiPriorityOP'
                    url='global-filter?where=workorders$department$isEnabled€1&='
                    placeHolder={
                        ERP_TYPE == 'MEX' ? 'Select a Department' : 'Select a Branch'
                    }
                    value={departmentFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectDepartmentordersFilterMultiPriorityOP',
                                '{"value":[]}'
                            );
                        }
                        departmentFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const SectionFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            sectionFMSCom = scope;
                        }}
                        field={{value: 'value', text: 'alias'}}
                        id='SectionordersFilterMultiOP'
                        url='global-filter?where=workorders$section$isEnabled€1&='
                        placeHolder='Select a Section'
                        value={sectionFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectSectionordersFilterMultiOP',
                                    '{"value":[]}'
                                );
                            }
                            sectionFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const PontoReferenceFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            prontoReferenceFMSCom = scope;
                        }}
                        field={{value: 'value', text: 'alias'}}
                        id='ProntoReferenceOrdersFilterMultiOP'
                        url='global-filter?where=workorders$reference$isEnabled€1&='
                        placeHolder='Select a Reference'
                        value={prontoReferenceFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectProntoReferenceOrdersFilterMultiOP',
                                    '{"value":[]}'
                                );
                            }
                            prontoReferenceFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const HoldReasonFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            holdReasonFMSCom = scope;
                        }}
                        field={{value: 'value', text: 'alias'}}
                        id='reasonOrdersFilterMultiOP'
                        url='global-filter?where=workorders$reason$isEnabled€1&='
                        placeHolder='Select a Hold Reason'
                        value={holdReasonFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectreasonOrdersFilterMultiOP',
                                    '{"value":[]}'
                                );
                            }
                            holdReasonFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const RevisionCodeFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            revisionCodeFMSCom = scope;
                        }}
                        field={{value: 'value', text: 'alias'}}
                        id='revisionOrdersFilterMultiOP'
                        url='global-filter?where=workorders$revision$isEnabled€1&='
                        placeHolder='Select a Revision'
                        value={revisionCodeFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectrevisionOrdersFilterMultiOP',
                                    '{"value":[]}'
                                );
                            }
                            revisionCodeFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    const ReferenceInput = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        enablePersistence={true}
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            referenceFMSCom = scope;
                        }}
                        autocomplete='off'
                        showClearButton
                        placeholder='Reference'
                        id='ReferenceTextBoxOP'
                        value={referenceFMSComValue}
                        onChange={(args: any) => {
                            // referenceFMSComValue = args.target.value;
                            setreferenceFMSComValue(args.target.value);
                        }}
                    />
                )}
            </div>
        );
    };
    const AssetInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        assetFMSCom = scope;
                    }}
                    autocomplete='off'
                    showClearButton
                    placeholder='Asset'
                    id='AssetTextBoxOP'
                    enablePersistence={true}
                    value={assetFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxAssetTextBoxOP', '{"value":""}');
                        }

                        assetFMSComValue = args.target.value;
                    }}
                />
            </div>
        );
    };
    const WorkOrderCodeInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        workorderCodeFMSCom = scope;
                    }}
                    autocomplete='off'
                    enablePersistence={true}
                    showClearButton
                    id='WorkOrderTextBoxOP'
                    placeholder='Work Order'
                    value={workorderCodeFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxWorkOrderTextBoxOP', '{"value":""}');
                        }

                        workorderCodeFMSComValue = args.target.value;
                    }}
                />
            </div>
        );
    };
    const AssetParentCodeInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        parentAssetFMSCom = scope;
                    }}
                    autocomplete='off'
                    showClearButton
                    placeholder='Parent WO'
                    id='ParentWoTextBoxOP'
                    enablePersistence={true}
                    value={parentAssetFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxParentAssetTextBoxOP', '{"value":""}');
                        }
                        parentAssetFMSComValue = args.target.value;
                    }}
                />
            </div>
        );
    };
    const TypeInput = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        typeFMSCom = scope;
                    }}
                    //field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                    field={
                        erpTypeName === ERP_TYPE
                            ? {value: 'value', text: 'description'}
                            : {value: 'value', text: 'alias'}
                    }
                    id='operationFilterMultiTypeOP'
                    //url='system-config?where=P3'
                    url={'global-filter?where=workorders$type$isEnabled€1'}
                    placeHolder='Select a Type'
                    value={typeFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectoperationFilterMultiTypeOP',
                                '{"value":[]}'
                            );
                        }

                        typeFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    const hasProblemComponent = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        hasProblem = scope;
                    }}
                    field={{value: 'value', text: 'alias'}}
                    id='hasProblemFilterMultiOP'
                    url={'global-filter?where=workorders$problem$isEnabled€1'}
                    placeHolder='Data Integrity'
                    value={hasProblemValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselecthasProblemFilterMultiOP',
                                '{"value":[]}'
                            );
                        }

                        hasProblemValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    //global-filter?where=workorders$type$isEnabled€1
    const RespInput = () => {
        return (
            <>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope) => {
                            respFMSCom = scope;
                        }}
                        field={{value: 'value', text: 'alias'}}
                        id='ordersFilterMultiRespOP'
                        //url='system-config?where=P2'
                        url='global-filter?where=workorders$responsibility$isEnabled€1'
                        placeHolder='Select a Resp'
                        onChange={(e) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectordersFilterMultiRespOP',
                                    '{"value":[]}'
                                );
                            }
                            respFMSComValue = e.value;
                        }}
                        value={respFMSComValue}
                        enablePersistence={true}
                    />
                )}
            </>
        );
    };

    const ScheduleStartDateInput = () => {
        return (
            <div>
                <DateRangePickerComponent
                    placeholder='Schedule Start Date'
                    id='ScheduleStartDateFilterOP'
                    ref={(a) => {
                        startDateFMSCom = a;
                    }}
                    enablePersistence={true}
                    enabled={true}
                    format={'dd/MM/yyyy'}
                    showClearButton={true}
                    value={schdeduleStartDateVal}
                    onChange={(e: any) => {
                        if (e.value == null) {
                            localStorage.setItem(
                                'daterangepickerScheduleStartDateFilterOP',
                                '{"startDate":null,"endDate":null,"value":""}'
                            );
                        }

                        schdeduleStartDateVal = e.value;
                    }}
                ></DateRangePickerComponent>
            </div>
        );
    };

    const PlannedStartDateInput = () => {
        return (
            <div>
                <DateRangePickerComponent
                    placeholder='Planned Start Date'
                    id='PlannedStartDateFilterOP'
                    ref={(a) => {
                        plannedStartDateFMSCom = a;
                    }}
                    enablePersistence={true}
                    enabled={true}
                    format={'dd/MM/yyyy'}
                    showClearButton={true}
                    value={plannedStartDateVal}
                    onChange={(e: any) => {
                        if (e.value == null) {
                            localStorage.setItem(
                                'daterangepickerPlannedStartDateFilterOP',
                                '{"startDate":null,"endDate":null,"value":""}'
                            );
                        }

                        plannedStartDateVal = e.value;
                    }}
                ></DateRangePickerComponent>
            </div>
        );
    };
    useEffect(() => {
        const isFilterActiveLS = localStorage.getItem('isFilterActive');
        if (isFilterActiveLS !== null) {
            setIsFilterActive(JSON.parse(isFilterActiveLS));
        }
    }, []);
    useEffect(() => {
        const get = async () => {
            await getColor();
        };
        get();
        socket.on('OnDeletedOrdersFeedback', (data: any) => {
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });

        socket.on('OnSyncQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                buildQuery();
                Message.success(theMessage);
            }
        });
        socket.on('OnGetNewRecordQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                buildQuery();
                Message.success(theMessage);
            }
        });
        socket.on('onSyncOperationQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });
        socket.on('OnResetOperationQueryFeedback', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });
        socket.on('OnResetDataQueryFeedbackOperationTab', (data: any) => {
            isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                buildQuery();
                Message.success(theMessage);
            }
        });
        socket.connect();
        return () => {
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
            if (reduxSearchS.planId !== undefined) {
                setPlanId(reduxSearchS.planId);
            }
    }, [reduxSearchS.planId]);

    useEffect(() => {
        if (
            reduxSearchS.isOpPlanSelected &&
            (reduxSearchS.searchCaseOperation === '' ||
                !reduxSearchS.searchCaseOperation)
        ) {
            setPlanId(reduxSearchS.planId)
            getBusinessLogic();
        }
    }, [reduxSearchS.isOpPlanSelected]);

    // useEffect(() => {
    //   searchTextBox && (searchTextBox.value = searchText);
    //   PriorityColorData?.map((elCol: any) => {
    //     $(`.e-chip-text${elCol.priority_code?.trim()}`).css(
    //         'background-color',
    //         `${elCol?.priority_color}`
    //     );
    //     var el = document.getElementsByClassName(
    //         `e-chip-text${elCol.priority_code?.trim()}`
    //     )[0] as any;
    //     if (el) {
    //       el.style.backgroundColor = elCol?.priority_color;
    //     }
    //   });
    // });
    useEffect(() => {
        if (reduxSearchS.searchCaseOperation && reduxSearchS.searchCaseOperation !== '') {
            $('#operation-search').val(reduxSearchS.searchCaseOperation);
            setTheSearchText(reduxSearchS.searchCaseOperation);
        }
    }, [reduxSearchS.searchCaseOperation]);

    useEffect(() => {
        console.log("theSearchText: ",theSearchText)
        if (theSearchText) {
            buildQuery(false);
        }
    }, [theSearchText]);

    const queryCellInfo = (args: any) => {
        if (
            args.column.field === 'estHours' ||
            args.column.field === 'duration' ||
            args.column.field === 'required'
        ) {
            args.cell.innerHTML = Number(args.cell.innerHTML).toFixed(2);
        }

        if (
            args.column &&
            args.column.type === 'checkbox' &&
            args.data &&
            args.cell
        ) {
            let theData = args.data as any;
            if (theData) {
                let isEffected = theData.isEffected;
                let theCurrenColor = 'tranparent';
                if (isEffected) {
                    theCurrenColor = '#8ECDDD';
                }
                args.cell.setAttribute('style', `background-color:${theCurrenColor};`);
            }
        }
    };
    const excelExportsColumns: any = [
        {field: 'WorkOrderDescription', headerText: '', width: 300},
        {field: 'StartDate', headerText: 'Sched. Date', width: 100},
        {field: 'asset_code', headerText: 'Plant Item', width: 80},
        {field: 'asset_description', headerText: 'Plant Description', width: 100},
        {field: 'orderCode', headerText: 'W/O #', width: 80},
        {field: 'TaskName', headerText: 'Work Order Description', width: 400},
        {field: 'pm_schedule_id', headerText: 'PM Task', width: 80},
        {field: 'type_code', headerText: 'Type', width: 80},
        {field: 'site_details_1', headerText: 'Reference', width: 80},
        //{ field: 'reason', headerText: 'Hold Reason' , width: 80},
        {field: 'order_resp_code', headerText: 'Resp', width: 80},
        {field: 'priority_code', headerText: 'Priority', width: 80},
        {field: 'teamCode', headerText: 'uWork Team', width: 80},
        {field: 'shift', headerText: 'uWork Shift', width: 80},
        {field: 'tradeCode', headerText: 'Lab.', width: 80},
        {field: 'required', headerText: 'Qty.', width: 80},
        {field: 'estHours', headerText: 'Hrs', width: 80},
        {field: 'section', headerText: 'Section', width: 80},
        {field: 'plannedBy', headerText: 'Plan By', width: 80},

        // { field: 'plannedBy', headerText: 'Cost Act.' , width: 80},
        // { field: 'plannedBy', headerText: 'Cost Bud.' , width: 80},
        // { field: 'plannedBy', headerText: 'Technician' , width: 80},
        // { field: 'plannedBy', headerText: 'Permit' , width: 80},
        // { field: 'plannedBy', headerText: 'High Risk Work' , width: 80},
        // { field: 'plannedBy', headerText: 'RSCHD Date' , width: 80},
        // { field: 'plannedBy', headerText: 'RSCHD Code' , width: 80},
    ];

    const calculateEndDate = (startDate: string, estHours: number | undefined, required: number | undefined): string => {
        if (!estHours || !required || required === 0) return startDate;
            const hoursPerPerson = parseFloat((estHours / required).toFixed(2));
            let date = new Date(startDate);
            date.setMinutes(date.getMinutes() + hoursPerPerson * 60);
            return date.toISOString();
        };

    const calculateDuration = (estHours: number | undefined, required: number | undefined): number => {
        if (!estHours || !required || required === 0) return 0;
            return parseFloat((estHours / required).toFixed(2));
        };

    const massCallBack = async (args: any) => {
        const selectedRecords = gridCPOp?.current?.getSelectedRecords() as any[];
        if (!selectedRecords || selectedRecords.length === 0) {
            Message.error('No records selected');
            return;
        }

        const updatedOperation: any[] = [];

        selectedRecords.forEach((rowData: any) => {
            let endDate: string | undefined = rowData.scheduled_end_date;
            let duration: number | undefined = rowData.duration;

            if (args.scheduled_end_date) {
                endDate = args.scheduled_end_date;
            } else {
                endDate = calculateEndDate(
                    args.scheduled_start_date ?? rowData.scheduled_start_date,
                    args.estHours ?? rowData.estHours,
                    args.required ?? rowData.required
                );
            }

            if (args.duration) {
                duration = args.duration;
            } else {
                duration = calculateDuration(
                    args.estHours ?? rowData.estHours,
                    args.required ?? rowData.required
                );
            }

            const updatedObject: any = {
                operationId: parseInt(rowData.operationId),
                scheduled_start_date: args?.scheduled_start_date ?? rowData.scheduled_start_date,
                scheduled_end_date: endDate,
                required: args?.required?.toString(),
                estHours: args?.estHours,
                operationDescription: args?.long_description,
                teamCode: args?.teamCode,
                tradeCode: args?.tradeCode,
                shiftId: args?.shiftId,
                duration: duration?.toString(),
                longDescription: args?.long_description ?? rowData.longDescription,
                shift: args?.shift ? args?.shift : rowData.shift,
            };

            if (args?.tradeCode && tradeData.length > 0) {
                const matchedTrade = tradeData.find(
                    (t: any) => t.trade_code === args.tradeCode
                );
                if (matchedTrade) {
                    updatedObject.tradeId = matchedTrade.trade_id;
                    updatedObject.tradeTypeId = matchedTrade.trade_type_id;
                }
            }

            Object.keys(updatedObject).forEach(
                (key) => updatedObject[key] === undefined && delete updatedObject[key]
            );

            updatedOperation.push(updatedObject);
        });

        loadingShow(true, 'Processing...');
        await EditOperations(updatedOperation).then((res: any) => {
            if (res.status === 200) {
                Message.success('Operation(s) updated successfully');
                buildQuery();
            }
            }).catch(() => {
            Message.error('Update failed!');
        }).finally(() => {
            loadingShow(false);
        });
    };

    const toolbarClick = async (args: any) => {
        if (args.item.id === 'refresh') {
            buildQuery();
            //getBusinessLogic();
        }
        if (args.item.id === 'scheduler') {
            if (gridCPOp?.current?.selectionModule.getSelectedRecords().length !== 0) {
                setHideSchedulerTimeDialog(true);
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'assign_workorders') {
            let datas: Array<any>;
            if (gridCPOp?.current?.checkAllRows === "Check") {
                datas = gridCPOp?.current?.dataSource as any[];
            } else {
                datas = gridCPOp?.current?.getSelectedRecords() as any
            }
            if (datas.length > 0) {
                const uniqueDataMap = new Map<string, any>();
                datas.forEach((item: any) => {
                    if (item.orderCode && !uniqueDataMap.has(item.orderCode)) {
                        uniqueDataMap.set(item.orderCode, item);
                    }
                });

                let transformedData = Array.from(uniqueDataMap.values()).map((item: any) => ({
                    order_code: item.orderCode ?? undefined,
                    order_id: item.orderId ?? undefined,
                    organization_Id: item.organizationId ?? undefined,
                }));

                setSelectedOrderDatas(transformedData);
                setHideDialogEventPlan(true);
            } else {
                Message.error('Select an operation to Assign...');
            }
        }
        if (args.item.id === 'ExcelExport') {
            const ganttData = gridCPOp?.current?.currentViewData || [];
            const grouped = groupTasksByDate(ganttData);
            const transformed = transformToMultiTableFormat(grouped);
            args.data = transformed;

            gridCPOp.current?.excelExport({
                dataSource: transformed,
                columns: excelExportsColumns,
            });
        }
        if (args.item.id === 'super_schedule') {
            const theDatas = gridCPOp?.current?.getSelectedRecords() as any[];
            if (theDatas && theDatas.length > 0) {
                setIsEditingOrder(false);
                setMassiveEditDialog(true);
            } else {
                Message.error('No records selected');
            }
        }
        if (args.item.id === 'reset_pronto_data') {
            if ((gridCPOp.current?.selectionModule?.getSelectedRecords().length || 0) > 0) {

                var selectedDatas = gridCPOp.current?.selectionModule?.getSelectedRecords() ||[]
                let uniqueByOrderRowId: Array<any> = [];
                if (selectedDatas?.length > 0) {
                    uniqueByOrderRowId = selectedDatas.filter(
                        (item: any, index, self) =>
                            index === self.findIndex((t: any) => t.order_row_id === item.order_row_id)
                    );
                }
                let orderRowIds = uniqueByOrderRowId
                    .map((x: any) => x.order_row_id)
                    .toString();
                if (selectedDatas.length > 0) {
                    let theQuery = `Select *
                                    from job5mfj
                                    where job5mfj.row_id in (${orderRowIds});`;
                    Message.info('Please wait for the response. It may take a while');
                    let count: number = 11;
                    let interval = setInterval(() => {
                        count--;
                        //loadingShow(true, 'Checking... ' + count + ' seconds');
                        if (count === 0) {
                            clearInterval(interval);
                            isAgentAlive = false;
                            // Message.info('No response to procced. Please try again later.');
                            // Message.error(
                            //     'Windows Agent is not currently available, please contact system administrator.'
                            // );
                            loadingShow(false);
                        }
                        if (isAgentAlive) {
                            clearInterval(interval);
                            isAgentAlive = false;
                            loadingShow(false);
                        }
                    }, 1000);
                    SendRequest(theQuery, 'RESET DATA', undefined, true);
                } else {
                    Message.info('Select order');
                }
            }
        }
        if (args.item.id === 'sync_from_erp') {
            if ((gridCPOp.current?.selectionModule?.getSelectedRecords().length || 0) > 0) {
                var selectedDatas = gridCPOp.current?.selectionModule?.getSelectedRecords() || []
                let uniqueByOrderRowId: Array<any> = [];
                if (selectedDatas?.length > 0) {
                    uniqueByOrderRowId = selectedDatas.filter(
                        (item: any, index, self) =>
                            index === self.findIndex((t: any) => t.order_row_id === item.order_row_id)
                    );
                }
                let orderRowIds = uniqueByOrderRowId
                    .map((x: any) => x.order_row_id)
                    .toString();

                let theQuery = `Select *
                                from job5mfj
                                where job5mfj.row_id in (${orderRowIds});`;
                Message.info('Please wait for the response. It may take a while');
                let count: number = 11;
                // let interval = setInterval(() => {
                //   count--;
                //   loadingShow(true, 'Checking... ' + count + ' seconds');
                //   if (count === 0) {
                //     clearInterval(interval);
                //     isAgentAlive = false;
                //     // Message.info('No response to procced. Please try again later.');
                //     // Message.error(
                //     //     'Windows Agent is not currently available, please contact system administrator.'
                //     // );
                //     loadingShow(false);
                //   }
                //   if (isAgentAlive) {
                //     clearInterval(interval);
                //     isAgentAlive = false;
                //     loadingShow(false);
                //   }
                // }, 1000);
                SendRequest(theQuery, 'SYNCED', undefined, true);
            } else {
                Message.error('Please select an order');
            }
        }

        if (args.item.id === 'update_pronto_api') {
            if (gridCPOp.current?.selectionModule.getSelectedRecords().length !== 0) {
                let objects: Array<any> = [{module: 'scheduler'}];
                var theData = gridCPOp.current?.selectionModule.getSelectedRecords() as any;
                var parentdata: any;
                theData.map((data: any) => {
                    if (data.orderCode) {
                        let obj = {
                            order_code: data.orderCode,
                        };
                        objects.push(obj);
                    }
                });
                objects = Array.from(
                    new Set(objects.map((item: any) => JSON.stringify(item)))
                ).map((item) => JSON.parse(item));

                gridCPOp.current?.showSpinner();
                EditProntoOrders(objects)
                    .then((result: AxiosResponse) => {
                        gridCPOp.current?.hideSpinner();
                        if (result.data.status == 200) {
                            loadingShow(false);
                            Message.success(`${result.data.message}...`);
                        }
                        if (result.data.status == 401 || result.data.status == 500) {
                            loadingShow(false);
                            Message.error(`${result.data.message}...`);
                        }
                        buildQuery();
                    })
                    .catch((err) => {
                        loadingShow(false);
                        Message.error('Update failed!!!');
                    });
            }
        }
        if (args.item.id === 'update_mex_workordertrade') {
            if (gridCPOp.current?.selectionModule.getSelectedRecords().length !== 0) {
                let objects: Array<any> = [];
                var theData = gridCPOp.current?.selectionModule.getSelectedRecords() as any;
                theData.map((data: any) => {
                        if (data.operationId) {
                        let obj = {
                            operationId: data.operationId,
                        };
                        objects.push(obj);
                    }
                });
                objects = Array.from(
                    new Set(objects.map((item: any) => JSON.stringify(item)))
                ).map((item) => JSON.parse(item));

                gridCPOp.current?.showSpinner();
                EditWorkOrderTrades(objects)
                    .then((result: AxiosResponse) => {
                        gridCPOp.current?.hideSpinner();
                        if (result.data.status == 200) {
                            loadingShow(false);
                            Message.success(`${result.data.message}...`);
                        }
                        if (result.data.status == 401 || result.data.status == 500) {
                            loadingShow(false);
                            Message.error(`${result.data.message}...`);
                        }
                        buildQuery();
                    })
                    .catch((err) => {
                        loadingShow(false);
                        Message.error('Update failed!!!');
                    });
            }
        }
        if (args.item.id === 'fetchRecords_from_pronto') {
            let result = await GetMaxProntoRowIdData();
            let maxProntoRowId;
            if (result.status === 200) {
                maxProntoRowId = result.data;
            }

            let theQuery = `Select *
                            from job5mfj
                            where job_type = 'J'
                              and row_id > (${maxProntoRowId});`;
            Message.info('Please wait for the response. It may take a while');
            // let count: number = 11;
            // let interval = setInterval(() => {
            //   count--;
            //   loadingShow(true, 'Checking... ' + count + ' seconds');
            //   if (count === 0) {
            //     clearInterval(interval);
            //     isAgentAlive = false;
            //     Message.info('No response to procced. Please try again later.');
            //     Message.error(
            //         'Windows Agent is not currently available, please contact system administrator.'
            //     );
            //     loadingShow(false);
            //   }
            //   if (isAgentAlive) {
            //     clearInterval(interval);
            //     isAgentAlive = false;
            //     loadingShow(false);
            //   }
            // }, 1000);
            SendRequest(theQuery, 'SYNCED_NEW_RECORDS', undefined, true);
        }
        if (args.item.id === 'show_order') {
            let datas: Array<any>;
            if (gridCPOp?.current?.checkAllRows === "Check") {
                datas = gridCPOp?.current?.dataSource as any[];

            } else {
                datas = gridCPOp?.current?.getSelectedRecords() as any
            }
            if (datas?.length > 0) {
                let theDatas = datas;
                let theCodes = [...new Set(
                    theDatas.map((theData: any) => theData.orderCode)
                )].toString();
                dispatch(setSearchCaseOrder(theCodes));
                dispatch(setSearchCaseOp(''));
            }
        }
        if (args.item.id === 'show_resources') {
            if (gridCPOp.current?.getSelectedRecords() || [].length > 0) {
                let theDatas = gridCPOp.current?.getSelectedRecords() || [];
                let theCodes = theDatas
                    .map((theData: any) => {
                        return theData.orderCode;
                    })
                    .toString();
                dispatch(setSearchCaseGantt(theCodes));
            }
        }
        if (args.item.id === 'add_operation') {
            //selectedOrderCodes
            let planAndOrderCodes: Array<string> = [`${plan_id}`];
            if (gridCPOp.current?.getSelectedRecords() || [].length > 0) {
                let theDatas: any = gridCPOp.current?.getSelectedRecords() || [];

                theDatas.map((item: any) => {
                    currentTempName = item.longDescription;
                    currentTempId = item.pm_id;
                    if (!planAndOrderCodes.includes(item.orderCode)) {
                        planAndOrderCodes.push(item.orderCode);
                    }
                });
                setSelectedOrderDetail(theDatas);
                let joinedOrderCodes: string = planAndOrderCodes.join(',');
                setSelectedOrderCodes(joinedOrderCodes);
                setShowOperationTemplateModal(true);
            }
        }
    };
    const excelQueryCellInfo = (args: any) => {
        const data = args.data;

        if (!data || Object.keys(data).length === 0) {
            return;
        }

        const baseFontStyle = {
            fontName: 'Verdana',
            fontSize: 10,
            wrapText: true,
        };

        if (args.column?.field === 'WorkOrderDescription' && !data.isHeader && !data.isFooter) {
            args.cellValue = '';
            return;
        }

        if (data.isHeader) {
            args.style = {
                ...baseFontStyle,
                backColor: '#000000',
                fontColor: '#FFFFFF',
                bold: true,
            };
            return;
        }

        if (data.isFooter) {
            args.style = {
                ...baseFontStyle,
                backColor: '#FCE4D6',
                bold: true,
            };
            return;
        }

        if (['CC', 'HC', 'ST'].includes((data.site_details_1 || '').trim()) && args.column?.field === 'TaskName') {
            args.style = {
                ...baseFontStyle,
                backColor: '#FFFF00',
            };
            return;
        }

        if (data.pm_schedule_id == null && args.column?.field === 'TaskName') {
            args.style = {
                ...baseFontStyle,
                backColor: '#C6EFCE',
            };
            return;
        }

        if (data.pm_id != null && args.column?.field === 'TaskName') {
            args.style = {
                ...baseFontStyle,
                backColor: '#FFFF00',
            };
            return;
        }

        const dateStr = data.scheduled_start_date;
        if (dateStr) {
            const date = new Date(dateStr);
            const hour = date.getHours();

            if (!isNaN(hour)) {
                if (hour >= 6 && hour < 18) {
                    args.style = {
                        ...baseFontStyle,
                        backColor: '#FFFFFF',
                    };
                } else {
                    args.style = {
                        ...baseFontStyle,
                        backColor: '#D9D9D9',
                    };
                }
            }
        }
    };
    const theColumnOperations = [
        {
            field: 'ID',
            headerText: 'Plan ID',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: false,
            visible: false,
        },
        {
            field: 'id',
            headerText: 'ID',
            width: 60,
            clipMode: 'EllipsisWithTooltip',
            isPrimaryKey: true,
            allowEditing: false,
            visible: false,
        },
        {
            field: 'priority',
            headerText: 'Priority',
            width: 90,
            clipMode: 'EllipsisWithTooltip',
            template: priorityColor.bind(this),
            allowEditing: false,
        },
        {
            field: 'orderCode',
            headerText: 'Work Order Number',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: false,
        },
        {
            field: 'operationSequence',
            headerText: 'Op Sequence',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
        {
            field: 'operationDescription',
            headerText: 'Task Description',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
        {
            field: 'tradeCode',
            headerText: 'Trade',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            edit: tradeParams,
        },
        {
            field: 'required',
            headerText: 'Required',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            editType: 'numericedit',
            format: 'C2',
            edit: { params: { min: 0 } },
            allowEditing: true,
        },
        {
            field: 'estHours',
            headerText: 'Est Hours',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            editType: 'numericedit',
            format: 'C2',
            edit: { params: { min: 0 } },
            allowEditing: true,
        },
        {
            field: 'statusCode',
            headerText: 'Status',
            width: 150,
            clipMode: 'EllipsisWithTooltip',
            allowEditing: true,
        },
    ];

    return (
        <div>
            <GlobalSearch
                id={'cloud-planner-operations-filter'}
                height={ERP_TYPE == 'MEX' ? '720px' : '915px'}
                isFilterActive={isFilterActive}
                applyFilter={FilterPrio.bind(this)}
                clearFilter={clearFilter.bind(this)}
                Component1={PriorityMultiSelect.bind(this)}
                Component2={StatusMultiSelect.bind(this)}
                Component3={AssetInput.bind(this)}
                Component4={TypeInput.bind(this)}
                Component5={RespInput.bind(this)}
                Component6={ScheduleStartDateInput.bind(this)}
                Component7={ReferenceInput.bind(this)}
                Component8={WorkOrderCodeInput.bind(this)}
                Component9={DepartmentFilterInput.bind(this)}
                Component10={SectionFilterInput.bind(this)}
                Component11={PontoReferenceFilterInput.bind(this)}
                Component12={HoldReasonFilterInput.bind(this)}
                Component13={ScheduleNumberComponent.bind(this)}
                Component14={hasProblemComponent.bind(this)}
                Component15={RevisionCodeFilterInput.bind(this)}
                Component16={AssetParentCodeInput.bind(this)}
                Component17={TeamMultiSelect.bind(this)}
                Component18={ShiftMultiSelect.bind(this)}
                Component19={TradeMultiSelect.bind(this)}
                Component20={PlannedStartDateInput.bind(this)}
                //Component21={OPStatusMultiSelect.bind(this)}
            />
            <GridComponent
                id='cloudplanner-op-grid'
                dataSource={data}
                editSettings={editOptions}
                toolbar={toolbarOptions}
                ref={gridCPOp}
                filterSettings={FilterOptions}
                allowFiltering={true}
                allowSorting={true}
                showColumnChooser={true}
                selectionSettings={{persistSelection: true}}
                statelessTemplates={['toolbarTemplates']}
                dataBound={() => {
                    var searchEle = gridCPOp?.current?.element?.querySelector(
                        '#' + gridCPOp.current?.element.id + '_searchbar'
                    );
                    if (searchEle) {
                        searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
                    }
                }}
                allowPaging={true}
                showColumnMenu={true}
                toolbarClick={toolbarClick}
                pageSettings={pageOptions}
                allowReordering={true}
                allowResizing={true}
                allowGrouping={true}
                actionComplete={actionComplete.bind(this)}
                style={{marginTop: '10px'}}
                actionBegin={begin.bind(this)}
                gridLines='Both'
                //height='calc(-270px + 100vh)'
                height={!needExpandStatus ? 'calc(-320px + 100vh)' :
                    context.expandStatus
                        ? 'calc(40vh - 12px)'
                        : 'calc(-425px + 100vh)'
                }
                contextMenuItems={contextMenuItems}
                contextMenuClick={contextMenuClick.bind(this)}
                queryCellInfo={queryCellInfo.bind(this)}
                allowExcelExport={true}
                excelQueryCellInfo={excelQueryCellInfo.bind(this)}
            >
                <ColumnsDirective>
                    <ColumnDirective type='checkbox' width={35} allowEditing={false}/>
                    <ColumnDirective
                        field='operationId'
                        isPrimaryKey={true}
                        visible={false}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        width={90}
                        template={priorityColor.bind(this)}
                        field='priority'
                        headerText='Priority'
                        clipMode='EllipsisWithTooltip'
                        // edit={getParamsDD(
                        //   { value: 'value', text: 'alias' },
                        //   'priority',
                        //   'global-filter?where=operation$priority$isEnabled€1',
                        //   true
                        // )}
                    />
                    {/*<ColumnDirective*/}
                    {/*  field='materialStatus'*/}
                    {/*  allowEditing={false}*/}
                    {/* // template={materialColor.bind(this)}*/}
                    {/*  headerText='Material Status'*/}
                    {/*  width={50}*/}
                    {/*  clipMode='EllipsisWithTooltip'*/}
                    {/*/>*/}

                    <ColumnDirective
                        allowEditing={false}
                        field='ID'
                        headerText='Plan Id'
                        width={150}
                        clipMode='EllipsisWithTooltip'
                        visible={false}
                        // edit={assetParams}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        field='order_row_id'
                        headerText='WO ROW ID'
                        width={150}
                        clipMode='EllipsisWithTooltip'
                        visible={false}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        field='assetCode'
                        headerText='Asset Number'
                        width={175}
                        clipMode='EllipsisWithTooltip'
                        // edit={assetParams}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        field='orderCode'
                        headerText='Work Order Number'
                        width={150}
                        clipMode='EllipsisWithTooltip'
                        template={orderCodeTemplate.bind(this)}
                        // edit={orderParams}
                    />
                    <ColumnDirective
                        field='orderDescription'
                        headerText='WO Description'
                        width={350}
                        clipMode='EllipsisWithTooltip'
                        allowEditing={false}
                    />
                    <ColumnDirective
                        allowEditing={true}
                        field='operationSequence'
                        headerText='Op Sequence'
                        width={80}
                        clipMode='EllipsisWithTooltip'
                        template={operationSequenceTemplate.bind(this)}
                    />
                    <ColumnDirective
                        field='operationDescription'
                        headerText='Task Description'
                        width={400}
                        clipMode='EllipsisWithTooltip'
                        allowEditing
                    />
                    <ColumnDirective
                        field='tradeCode'
                        headerText='Trade'
                        width={100}
                        clipMode='EllipsisWithTooltip'
                        edit={getParamsDD(
                            {text: 'label', value: 'trade_code'},
                            'tradeCode',
                            'trade',
                            true
                        )}
                    />
                    <ColumnDirective
                        field='required'
                        headerText='Required'
                        editType='numericedit'
                        width={60}
                        clipMode='EllipsisWithTooltip'
                        format='C2'
                        allowEditing={false}
                    />
                    <ColumnDirective
                        field='estHours'
                        headerText='Est Hours'
                        editType='numericedit'
                        width={60}
                        clipMode='EllipsisWithTooltip'
                        format='C2'
                        allowEditing={false}
                    />
                    <ColumnDirective
                        field='scheduled_start_date'
                        headerText='Scheduled Start Date'
                        allowEditing={false}
                        width={200}
                        clipMode='EllipsisWithTooltip'
                        type='datetime'
                        format='dd/MM/yyyy HH:mm'
                        edit={{params: {format: 'dd/MM/yyyy HH:mm'}}}
                    />
                    <ColumnDirective
                        field='scheduled_end_date'
                        headerText='Scheduled Finish Date'
                        allowEditing={false}
                        width={200}
                        clipMode='EllipsisWithTooltip'
                        type='datetime'
                        format='dd/MM/yyyy HH:mm'
                    />
                    <ColumnDirective
                        field='teamCode'
                        headerText='Team'
                        allowEditing={false}
                        width={90}
                        clipMode='EllipsisWithTooltip'
                        /* edit={getParamsDD(
            { text: 'team_code', value: 'team_id' },
            'team',
            'team',
          )} */
                    />
                    <ColumnDirective
                        field='shift'
                        headerText='Shift'
                        allowEditing={false}
                        width={90}
                        clipMode='EllipsisWithTooltip'
                        /* edit={getParamsDD(
            { text: 'rosterCode', value: 'rosterId' },
            'shift',
            'shift'
          )} */
                    />
                    {process.env.REACT_APP_ERP_TYPE == 'MEX' ? null : (
                        <ColumnDirective
                            allowEditing={false}
                            field='responsibility'
                            headerText='Responsibility'
                            width={60}
                            clipMode='EllipsisWithTooltip'
                            // edit={getParamsDD(
                            //   { value: 'sys_tbl_code', text: 'sys_description' },
                            //   'responsibility',
                            //   'system-config?where=P2',
                            //   true
                            // )}
                        />
                    )}
                    <ColumnDirective
                        field='workOrderType'
                        headerText='Work Order Type'
                        allowEditing={false}
                        width={100}
                        clipMode='EllipsisWithTooltip'
                        // edit={getParamsDD(
                        //   { value: 'sys_tbl_code', text: 'sys_description' },
                        //   'workOrderType',
                        //   'system-config?where=P3',
                        //   true
                        // )}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        field='section'
                        width={150}
                        headerText='Section'
                        clipMode='EllipsisWithTooltip'
                        // edit={getParamsDD(
                        //   { value: 'sys_tbl_code', text: 'sys_description' },
                        //   'workOrderType',
                        //   'system-config?where=N4',
                        //   true
                        // )}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        field='order_status_code'
                        headerText='WO Status'
                        width={150}
                        clipMode='EllipsisWithTooltip'
                    />
                    <ColumnDirective
                        field='revision_code'
                        headerText='Revision'
                        width={150}
                        visible={process.env.REACT_APP_ERP_TYPE === 'MEX' ? false : true}
                        clipMode='EllipsisWithTooltip'
                        allowEditing={false}
                        template={revisionTemplate}
                    />
                    <ColumnDirective
                        field='asset_code_parent'
                        headerText='Parent WO'
                        width={150}
                        visible={process.env.REACT_APP_ERP_TYPE === 'MEX' ? false : true}
                        clipMode='EllipsisWithTooltip'
                        allowEditing={false}
                    />
                    <ColumnDirective
                        field='plannedStartDate'
                        headerText='Planned Start Date'
                        allowEditing={false}
                        width={200}
                        clipMode='EllipsisWithTooltip'
                        type='datetime'
                        format='dd/MM/yyyy HH:mm'
                        edit={{params: {format: 'dd/MM/yyyy HH:mm'}}}
                    />
                    <ColumnDirective
                        field='planned_end_date'
                        headerText='Planned End Date'
                        allowEditing={false}
                        width={200}
                        clipMode='EllipsisWithTooltip'
                        type='datetime'
                        format='dd/MM/yyyy HH:mm'
                    />
                    {/* <ColumnDirective
            allowEditing={false}
            field='actHours'
            headerText='Actual Hours'
            width={150}
            clipMode='EllipsisWithTooltip'
          /> */}
                    <ColumnDirective
                        allowEditing={false}
                        field='statusCode'
                        headerText='Status'
                        width={150}
                        clipMode='EllipsisWithTooltip'
                        // edit={getParamsDD(
                        //   { value: 'value', text: 'alias' },
                        //   'statusCode',
                        //   'global-filter?where=operation$status$isEnabled€1'
                        // )}
                    />
                    <ColumnDirective
                        allowEditing={false}
                        field='plannedBy'
                        headerText='Planned By'
                        width={150}
                        clipMode='EllipsisWithTooltip'
                    />
                </ColumnsDirective>
                <Inject
                    services={[
                        Edit,
                        Toolbar,
                        Filter,
                        Page,
                        ColumnChooser,
                        ColumnMenu,
                        Resize,
                        Reorder,
                        ContextMenu,
                        Group,
                        Sort,
                    ]}
                />
            </GridComponent>
            <TooltipComponent
                target=".order-code-cell"
                position="TopCenter"
                opensOn="Hover"
                showTipPointer={true}
                cssClass="custom-syncfusion-tooltip"
            />
            <GlobalDialog
                showDialog={hideDeleteDialog}
                setShowDialog={(val: boolean) => setHideDeleteDialog(val)}
                header={`Confirm Shift Assign`}
                width={'250px'}
                hideDoneButton={true}
                buttons={buttonShiftAssignment}
            >
                <GlobalDropDown
                    id='cloudplanner-operations-shift'
                    placeHolder='Shift'
                    url='shift/Shift'
                    field={{text: 'rosterCode', value: 'rosterId'}}
                    refDD={(scope: DropDownListComponent) =>
                        (dropDownListObjectShiftElment = scope)
                    }
                    itemTemplate={itemTemplateShiftColor}
                    floatLabelType='Always'
                    actionComplete={onShiftActionComplete}
                />
            </GlobalDialog>
            {hideAssignTeamDialog &&
                <GlobalDialog
                    showDialog={hideAssignTeamDialog}
                    setShowDialog={(val: boolean) => setHideAssignTeamDialog(val)}
                    header={`Confirm Team Assign`}
                    width={'250px'}
                    hideDoneButton={true}
                    buttons={buttonTeamAssignment}
                >
                    <GlobalDropDown
                        id='cloudplanner-operations-team'
                        placeHolder='Team'
                        url='team'
                        field={{text: 'team_code', value: 'team_id'}}
                        refDD={(scope: DropDownListComponent) =>
                            (dropDownListObjectTeamElment = scope)
                        }
                        floatLabelType='Always'
                        actionComplete={onTeamActionComplete}
                    />
                </GlobalDialog>
            }
            {showOperationTemplateModal &&
                <GlobalDialog
                    // refDialog={(ref: DialogComponent) => (this.dialog = ref)}
                    showDialog={showOperationTemplateModal}
                    setShowDialog={(val: boolean) => setShowOperationTemplateModal(val)}
                    header={`Operations`}
                    width={'85%'}
                    height={'60%'}
                    hideDoneButton={false}
                >
                    <GlobalGrid
                        fromComponent='operation-template-detail'
                        gridRef={(g: GridComponent) => (gridOpTemplate = g)}
                        toolbarClickItems={handleToolbarClick}
                        id='operation-template-detail'
                        columns={theColumnOperations}
                        height={'calc(-600px + 90vh)'}
                        signalOfLoad={true}
                        query={selectedOrderCodes ? selectedOrderCodes : `${plan_id},0`}
                        toolbarOptions={toolbarOptionsForDetail}
                        get_query={'operation/template/detail-by-orderId'}
                        theEditOptions={editOptionsOperationTemplateDialog}
                        //edit_query={'gant/op/edit'}
                        add_query={'gant/op/edit-temp'}
                        delete_query={'operation/template/detail/delete'}
                        noNeedPagination={true}
                        queryCellInfo={queryCellInfo}
                        additionalCrudParams={{template_id: 108}}
                        //additinalToolbarClick={extendsToolbarClick}
                        mapFieldToType={[
                            {field: 'required', type: 'string'},
                            {field: 'duration', type: 'string'},
                            {field: 'est_hours', type: 'string'},
                        ]}
                    ></GlobalGrid>
                </GlobalDialog>
            }

            {hideSchedulerTimeDialog ? (
                <GlobalDialog
                    showDialog={hideSchedulerTimeDialog}
                    setShowDialog={(val) =>
                        setHideSchedulerTimeDialog(val)
                    }
                    header='Confirm Scheduler'
                    width={'350px'}
                    hideDoneButton={true}
                    buttons={buttonScheduler}
                >
                    <DateTimePickerComponent
                        placeholder='Select a range'
                        change={confirmSchedulerTime.bind(this)}
                        format={'dd/MM/yyyy HH:mm'}
                        value={defaultConfirmScheduleDate}
                        ref={(scope: DateTimePickerComponent) =>
                            (dateTimePicker = scope)
                        }
                    />
                </GlobalDialog>
            ) : null}
            {massiveEditDialog ? (
                <MassiveOrderEdit
                    isEditingOrder={false}
                    title='Mass Edit'
                    callback={massCallBack}  
                    massiveEditDialog={massiveEditDialog}
                    setMassiveEditDialog={(val: boolean) => {
                        setMassiveEditDialog(val);
                    }}
                />
            ) : null}
            {/*{hideDialogOrder ? (*/}
            {/*  <GlobalPlannedOrderGrid*/}
            {/*    hideDialogOrder={hideDialogOrder}*/}
            {/*    setHideDialogOrder={setHideDialogOrder}*/}
            {/*    getPlanOrder={buildQuery.bind(this)}*/}
            {/*    plan_id={context.planId}*/}
            {/*  />*/}
            {/*) : null}*/}
            {hideDialogEventPlan ? (
                <AssignWorkOrderDialog
                    key={selectedOrderDatas.length}
                    hideDialogEventPlan={hideDialogEventPlan}
                    selectedOrders={selectedOrderDatas}
                    setHideDialogEventPlan={(val: boolean) => {
                        setHideDialogEventPlan(val);
                        buildQuery()
                    }}
                    theModel={selectedOrderDatas}
                />
            ) : null}
        </div>
    );
};
export default Operations;
